const colors = {
    1: {label: "Water", rgba: [65, 155, 223, 255]},
    2: {label: "Trees", rgba: [57, 125, 73, 255]},
    4: {label: "Flooded vegetation", rgba: [122, 135, 198, 255]},
    5: {label: "Crops", rgba: [228, 150, 53, 255]},
    7: {label: "Built Area", rgba: [196, 40, 27, 255]},
    8: {label: "Bare ground", rgba: [165, 155, 143, 255]},
    9: {label: "Snow/Ice", rgba: [168, 235, 255, 255]},
    10: {label: "Clouds", rgba: [97, 97, 97, 255]},
    11: {label: "Rangeland", rgba: [227, 226, 195, 255]}
};

const cssColors = Object.entries(colors).map(([key, {label, rgba: [r, g, b, a]}]) => ({
    id: key,
    label: label,
    color: `rgba(${r}, ${g}, ${b}, ${a / 255})`
}));


export let LegendValues = cssColors;

export const PlotType = [{
    label: 'Distribution (in Hectares)',
    value: 'Distribution',
}, {
    label: 'Distribution (in Percentage)',
    value: 'DistributionPercentage',
}, {
    label: 'Trend',
    value: 'Trend',
}];


let NepalExtent1 = [8912067.792153064, 3042216.9039533343, 9818551.628332129, 3564491.268202734]
export let NepalExtent = NepalExtent1;

export const LCYear = [
    {
        value: '2017',
        label: '2017',
    },
    {
        value: '2018',
        label: '2018',
    },
    {
        value: '2019',
        label: '2019',
    },
    {
        value: '2020',
        label: '2020',
    },
    {
        value: '2021',
        label: '2021',
    },
    {
        value: '2022',
        label: '2022',
    },
    {
        value: '2023',
        label: '2023',
    }, {
        value: '2024',
        label: '2024',
    },
];


export const AdministrativeLabelOption = [{
    label: 'Country Boundary',
    value: 0,
}, {
    label: 'Province',
    value: 1,
}, {
    label: 'District',
    value: 2,
}, {
    label: 'Municipality',
    value: 3,
}];


export const ProvinceOption = [
    // {
    //     "label": "All Province",
    //     "value": 0,
    //     "extent": NepalExtent
    // },
    {
        "label": "Koshi",
        "value": 1,
        "extent": [
            9590820.652485032,
            3042216.9039533366,
            9818551.628332129,
            3263226.2950714524
        ]
    },
    {
        "label": "Madhesh",
        "value": 2,
        "extent": [
            9404690.610570852,
            3051480.316476184,
            9686407.319637716,
            3181450.368774625
        ]
    },
    {
        "label": "Bagmati",
        "value": 3,
        "extent": [
            9341782.05619735,
            3113363.9421940995,
            9637222.76912644,
            3297753.782072744
        ]
    },
    {
        "label": "Gandaki",
        "value": 4,
        "extent": [
            9225851.668829177,
            3178269.5380176236,
            9484186.626891743,
            3417878.7854334167
        ]
    },
    {
        "label": "Lumbini",
        "value": 5,
        "extent": [
            9023455.960556967,
            3164780.252082564,
            9354001.289198292,
            3359002.319583058
        ]
    },
    {
        "label": "Karnali",
        "value": 6,
        "extent": [
            9014756.298571197,
            3270278.093079681,
            9315250.240094759,
            3561163.5314825512
        ]
    },
    {
        "label": "Sudurpashchim",
        "value": 7,
        "extent": [
            8912067.792153062,
            3298794.2297540316,
            9106836.448214851,
            3564491.268202737
        ]
    }
];


export const DistrictOption = [
    // {
    //     "label": "All District",
    //     "value": 0,
    //     "provinceid": 0,
    //     "extent": NepalExtent
    // },
    {
        "label": "ACHHAM",
        "value": 1,
        "extent": [
            9019826.189379672,
            3343636.3642671397,
            9081657.774487745,
            3424943.2143606404
        ],
        "provinceid": 7
    },
    {
        "label": "ARGHAKHANCHI",
        "value": 2,
        "extent": [
            9211494.726044279,
            3217532.646334316,
            9276297.620585255,
            3263344.7989858845
        ],
        "provinceid": 5
    },
    {
        "label": "BAGLUNG",
        "value": 3,
        "extent": [
            9225851.668829175,
            3258733.6209480227,
            9314600.631763306,
            3329295.611166162
        ],
        "provinceid": 4
    },
    {
        "label": "BAITADI",
        "value": 4,
        "extent": [
            8932450.87169566,
            3414952.308292774,
            9006654.500097897,
            3466058.657632778
        ],
        "provinceid": 7
    },
    {
        "label": "BAJHANG",
        "value": 5,
        "extent": [
            8988599.445554225,
            3425488.632977121,
            9079762.651013307,
            3510523.5091814403
        ],
        "provinceid": 7
    },
    {
        "label": "BAJURA",
        "value": 6,
        "extent": [
            9035790.53005358,
            3410289.0674652653,
            9106836.44821485,
            3497022.0924703246
        ],
        "provinceid": 7
    },
    {
        "label": "BANKE",
        "value": 7,
        "extent": [
            9072375.412985291,
            3230534.861186,
            9149801.287229687,
            3291631.416106463
        ],
        "provinceid": 5
    },
    {
        "label": "BARA",
        "value": 8,
        "extent": [
            9447251.039546654,
            3104637.14674298,
            9492312.503663965,
            3169231.761144532
        ],
        "provinceid": 2
    },
    {
        "label": "BARDIYA",
        "value": 9,
        "extent": [
            9023455.960556965,
            3257657.1889676084,
            9102215.590076007,
            3334303.9651311897
        ],
        "provinceid": 5
    },
    {
        "label": "BHAKTAPUR",
        "value": 10,
        "extent": [
            9501331.883367397,
            3201129.696144635,
            9520601.841882305,
            3214803.4548961436
        ],
        "provinceid": 3
    },
    {
        "label": "BHOJPUR",
        "value": 11,
        "extent": [
            9673071.146517267,
            3109278.3288002266,
            9715464.218066154,
            3181510.513025112
        ],
        "provinceid": 1
    },
    {
        "label": "CHITAWAN",
        "value": 12,
        "extent": [
            9341782.056197349,
            3167890.488070904,
            9439509.263839517,
            3233911.803976215
        ],
        "provinceid": 3
    },
    {
        "label": "DADELDHURA",
        "value": 13,
        "extent": [
            8926080.808018992,
            3374780.6470266026,
            8993028.56203946,
            3429861.89233448
        ],
        "provinceid": 7
    },
    {
        "label": "DAILEKH",
        "value": 14,
        "extent": [
            9062522.963148717,
            3329058.0220909403,
            9120044.20058962,
            3392952.680554651
        ],
        "provinceid": 6
    },
    {
        "label": "DANG",
        "value": 15,
        "extent": [
            9119381.678618856,
            3208236.365140612,
            9218375.04929012,
            3284712.939240917
        ],
        "provinceid": 5
    },
    {
        "label": "DARCHULA",
        "value": 16,
        "extent": [
            8946090.267330328,
            3452868.493574321,
            9028971.315764638,
            3564491.2682027393
        ],
        "provinceid": 7
    },
    {
        "label": "DHADING",
        "value": 17,
        "extent": [
            9419655.066871168,
            3207268.931067123,
            9492226.860358035,
            3292733.7269247947
        ],
        "provinceid": 3
    },
    {
        "label": "DHANKUTA",
        "value": 18,
        "extent": [
            9701291.043517713,
            3104193.28800948,
            9749360.470569355,
            3147334.6782047953
        ],
        "provinceid": 1
    },
    {
        "label": "DHANUSHA",
        "value": 19,
        "extent": [
            9556579.813238971,
            3069655.9358985177,
            9602377.042707656,
            3140195.2391464
        ],
        "provinceid": 2
    },
    {
        "label": "DOLAKHA",
        "value": 20,
        "extent": [
            9560594.694321584,
            3182822.1610391657,
            9635213.80933029,
            3270941.6729290728
        ],
        "provinceid": 3
    },
    {
        "label": "DOLPA",
        "value": 21,
        "extent": [
            9171843.508045437,
            3340298.3855226836,
            9315250.240094755,
            3465862.199770625
        ],
        "provinceid": 6
    },
    {
        "label": "DOTI",
        "value": 22,
        "extent": [
            8964128.152600592,
            3366819.353731668,
            9037679.799035981,
            3432490.318036368
        ],
        "provinceid": 7
    },
    {
        "label": "GORKHA",
        "value": 23,
        "extent": [
            9397450.659904232,
            3223219.0834898017,
            9484186.626891742,
            3344136.463879244
        ],
        "provinceid": 4
    },
    {
        "label": "GULMI",
        "value": 24,
        "extent": [
            9241942.409091767,
            3238986.4966407465,
            9306883.274424616,
            3283155.096336769
        ],
        "provinceid": 5
    },
    {
        "label": "HUMLA",
        "value": 25,
        "extent": [
            9045392.706788369,
            3452857.030915445,
            9183581.404254995,
            3561163.5314825536
        ],
        "provinceid": 6
    },
    {
        "label": "ILAM",
        "value": 26,
        "extent": [
            9751531.126602188,
            3081626.097916733,
            9816680.265529037,
            3136745.410415716
        ],
        "provinceid": 1
    },
    {
        "label": "JAJARKOT",
        "value": 27,
        "extent": [
            9108154.665308516,
            3326259.987075342,
            9192771.209467549,
            3391876.801330617
        ],
        "provinceid": 6
    },
    {
        "label": "JHAPA",
        "value": 28,
        "extent": [
            9755549.4980889,
            3043874.7149288473,
            9817028.463931374,
            3099241.8898477675
        ],
        "provinceid": 1
    },
    {
        "label": "JUMLA",
        "value": 29,
        "extent": [
            9111074.112384867,
            3371741.306260914,
            9194006.215089278,
            3440465.667284522
        ],
        "provinceid": 6
    },
    {
        "label": "KABHREPALANCHOK",
        "value": 30,
        "extent": [
            9505215.475292092,
            3165199.174570187,
            9560215.157614645,
            3218353.8567718626
        ],
        "provinceid": 3
    },
    {
        "label": "KAILALI",
        "value": 31,
        "extent": [
            8957665.766292628,
            3298794.2297540344,
            9048928.979963753,
            3384313.98014119
        ],
        "provinceid": 7
    },
    {
        "label": "KALIKOT",
        "value": 32,
        "extent": [
            9068970.543525467,
            3371947.048735498,
            9130348.30945888,
            3434527.15839058
        ],
        "provinceid": 6
    },
    {
        "label": "KANCHANPUR",
        "value": 33,
        "extent": [
            8912067.792153059,
            3318714.7901435257,
            8967833.0118908,
            3393124.4045622055
        ],
        "provinceid": 7
    },
    {
        "label": "KAPILBASTU",
        "value": 34,
        "extent": [
            9205675.526204819,
            3175774.4130795132,
            9265448.307872139,
            3226375.4481601925
        ],
        "provinceid": 5
    },
    {
        "label": "KASKI",
        "value": 35,
        "extent": [
            9317497.33638201,
            3258768.9924833546,
            9381849.174058544,
            3326527.0909326044
        ],
        "provinceid": 4
    },
    {
        "label": "KATHMANDU",
        "value": 36,
        "extent": [
            9483143.457719596,
            3194914.769087787,
            9525133.101314383,
            3225993.8102384945
        ],
        "provinceid": 3
    },
    {
        "label": "KHOTANG",
        "value": 37,
        "extent": [
            9620915.276480958,
            3107511.848509404,
            9683150.430230377,
            3178573.083247367
        ],
        "provinceid": 1
    },
    {
        "label": "LALITPUR",
        "value": 38,
        "extent": [
            9487921.493692888,
            3173907.6153983255,
            9511507.962482436,
            3210379.6534835193
        ],
        "provinceid": 3
    },
    {
        "label": "LAMJUNG",
        "value": 39,
        "extent": [
            9371619.39293784,
            3255972.695783102,
            9428172.495204117,
            3313450.8791922764
        ],
        "provinceid": 4
    },
    {
        "label": "MAHOTTARI",
        "value": 40,
        "extent": [
            9537417.71939023,
            3073782.943651742,
            9567374.75608654,
            3144521.551875472
        ],
        "provinceid": 2
    },
    {
        "label": "MAKAWANPUR",
        "value": 41,
        "extent": [
            9424827.784001388,
            3143698.2699260195,
            9518961.096981663,
            3212735.8544480964
        ],
        "provinceid": 3
    },
    {
        "label": "MANANG",
        "value": 42,
        "extent": [
            9327365.151339136,
            3305187.6828283016,
            9414338.004632968,
            3362972.2779139434
        ],
        "provinceid": 4
    },
    {
        "label": "MORANG",
        "value": 43,
        "extent": [
            9711342.517751345,
            3042216.9039533394,
            9761694.659840941,
            3107671.5142734903
        ],
        "provinceid": 1
    },
    {
        "label": "MUGU",
        "value": 44,
        "extent": [
            9101745.803145053,
            3424777.6802285523,
            9220469.173744408,
            3499852.779858347
        ],
        "provinceid": 6
    },
    {
        "label": "MUSTANG",
        "value": 45,
        "extent": [
            9292900.426676529,
            3320351.287587795,
            9378416.388830872,
            3417878.7854334195
        ],
        "provinceid": 4
    },
    {
        "label": "MYAGDI",
        "value": 46,
        "extent": [
            9250630.300743299,
            3286609.1222310793,
            9336529.36384026,
            3349412.947601425
        ],
        "provinceid": 4
    },
    {
        "label": "NAWALPARASI_E",
        "value": 47,
        "extent": [
            9314876.20526442,
            3178269.538017626,
            9398842.995167064,
            3232568.397779208
        ],
        "provinceid": 4
    },
    {
        "label": "NAWALPARASI_W",
        "value": 48,
        "extent": [
            9303153.864058847,
            3166847.468583761,
            9340402.442472637,
            3210355.674241218
        ],
        "provinceid": 5
    },
    {
        "label": "NUWAKOT",
        "value": 49,
        "extent": [
            9460859.198680185,
            3218824.729165447,
            9517484.028953722,
            3260474.14642965
        ],
        "provinceid": 3
    },
    {
        "label": "OKHALDHUNGA",
        "value": 50,
        "extent": [
            9596125.666621367,
            3141814.067141576,
            9649845.104206009,
            3189367.991928967
        ],
        "provinceid": 1
    },
    {
        "label": "PALPA",
        "value": 51,
        "extent": [
            9265223.994060308,
            3206438.0375839714,
            9354001.28919829,
            3243785.863883385
        ],
        "provinceid": 5
    },
    {
        "label": "PANCHTHAR",
        "value": 52,
        "extent": [
            9739615.092977867,
            3105969.267492657,
            9805033.209699046,
            3178336.532640162
        ],
        "provinceid": 1
    },
    {
        "label": "PARBAT",
        "value": 53,
        "extent": [
            9301750.759452788,
            3249657.1786473324,
            9331103.628124608,
            3299458.747306508
        ],
        "provinceid": 4
    },
    {
        "label": "PARSA",
        "value": 54,
        "extent": [
            9404690.61057085,
            3121439.9382559666,
            9459159.597971851,
            3181450.3687746283
        ],
        "provinceid": 2
    },
    {
        "label": "PYUTHAN",
        "value": 55,
        "extent": [
            9193669.731011977,
            3233563.572801324,
            9250357.642270874,
            3294756.2565245777
        ],
        "provinceid": 5
    },
    {
        "label": "RAMECHHAP",
        "value": 56,
        "extent": [
            9550922.820819136,
            3153751.6768582272,
            9637222.769126438,
            3227866.147847268
        ],
        "provinceid": 3
    },
    {
        "label": "RASUWA",
        "value": 57,
        "extent": [
            9475775.075935466,
            3244571.327434036,
            9551223.958663141,
            3297753.782072747
        ],
        "provinceid": 3
    },
    {
        "label": "RAUTAHAT",
        "value": 58,
        "extent": [
            9480312.019273613,
            3091600.5572464024,
            9518244.034694832,
            3152593.452883
        ],
        "provinceid": 2
    },
    {
        "label": "ROLPA",
        "value": 59,
        "extent": [
            9167187.532240784,
            3260662.562658393,
            9234688.408653295,
            3319556.2315474492
        ],
        "provinceid": 5
    },
    {
        "label": "RUKUM_E",
        "value": 60,
        "extent": [
            9182265.77718529,
            3309043.9932522727,
            9256487.76674088,
            3359002.3195830607
        ],
        "provinceid": 5
    },
    {
        "label": "RUKUM_W",
        "value": 61,
        "extent": [
            9148749.898465645,
            3314808.6008004355,
            9206142.356454171,
            3374626.1105914
        ],
        "provinceid": 6
    },
    {
        "label": "RUPANDEHI",
        "value": 62,
        "extent": [
            9262246.92399382,
            3164780.2520825667,
            9310069.393081533,
            3219772.882462689
        ],
        "provinceid": 5
    },
    {
        "label": "SALYAN",
        "value": 63,
        "extent": [
            9099623.844509838,
            3270278.093079684,
            9176868.078704413,
            3330489.4443741166
        ],
        "provinceid": 6
    },
    {
        "label": "SANKHUWASABHA",
        "value": 64,
        "extent": [
            9678121.875174867,
            3140513.8310304936,
            9760187.067399614,
            3243637.363829707
        ],
        "provinceid": 1
    },
    {
        "label": "SAPTARI",
        "value": 65,
        "extent": [
            9627557.422472984,
            3051480.3164761867,
            9686407.319637716,
            3097386.071829191
        ],
        "provinceid": 2
    },
    {
        "label": "SARLAHI",
        "value": 66,
        "extent": [
            9497971.301083952,
            3091207.1253686375,
            9552965.069589507,
            3147876.516189332
        ],
        "provinceid": 2
    },
    {
        "label": "SINDHULI",
        "value": 67,
        "extent": [
            9508693.289812818,
            3113363.942194102,
            9616862.507923752,
            3179926.4870292586
        ],
        "provinceid": 3
    },
    {
        "label": "SINDHUPALCHOK",
        "value": 68,
        "extent": [
            9511318.32803615,
            3199944.7623857115,
            9580704.089308735,
            3274640.3534519332
        ],
        "provinceid": 3
    },
    {
        "label": "SIRAHA",
        "value": 69,
        "extent": [
            9588049.807768308,
            3067335.027943183,
            9635204.762051757,
            3115388.8905851105
        ],
        "provinceid": 2
    },
    {
        "label": "SOLUKHUMBU",
        "value": 70,
        "extent": [
            9613048.719964359,
            3165763.6373749045,
            9685913.270111943,
            3263226.295071454
        ],
        "provinceid": 1
    },
    {
        "label": "SUNSARI",
        "value": 71,
        "extent": [
            9674099.267527143,
            3049104.8675701017,
            9724183.011256633,
            3108327.975779282
        ],
        "provinceid": 1
    },
    {
        "label": "SURKHET",
        "value": 72,
        "extent": [
            9014756.298571195,
            3291557.46061388,
            9132696.45442663,
            3372880.2606183537
        ],
        "provinceid": 6
    },
    {
        "label": "SYANGJA",
        "value": 73,
        "extent": [
            9288471.925095377,
            3232360.786462215,
            9354380.85970684,
            3276942.946735823
        ],
        "provinceid": 4
    },
    {
        "label": "TANAHU",
        "value": 74,
        "extent": [
            9343764.283813052,
            3216377.172903271,
            9413036.052683508,
            3265339.9377404763
        ],
        "provinceid": 4
    },
    {
        "label": "TAPLEJUNG",
        "value": 75,
        "extent": [
            9734257.89618674,
            3157008.690482244,
            9818551.628332127,
            3243030.5085641476
        ],
        "provinceid": 1
    },
    {
        "label": "TERHATHUM",
        "value": 76,
        "extent": [
            9728423.784876032,
            3119467.1491208915,
            9768456.096983716,
            3160628.90630887
        ],
        "provinceid": 1
    },
    {
        "label": "UDAYAPUR",
        "value": 77,
        "extent": [
            9590820.65248503,
            3084324.450015169,
            9703556.884622307,
            3145961.4522063
        ],
        "provinceid": 1
    }
]


export const municipalityOption = [
    // {
    //     "label": "All Municipality",
    //     "value": 0,
    //     "districtid": 0,
    //     "extent": NepalExtent
    // },
    {
        "label": "Aamchowk",
        "value": 131,
        "extent": [
            9678625.482829154,
            3109278.3288002205,
            9697753.507907031,
            3130720.9276197655
        ],
        "districtid": 11
    },
    {
        "label": "Aandhikhola",
        "value": 340,
        "extent": [
            9321948.650477314,
            3263160.119334187,
            9334983.376481699,
            3276942.946735827
        ],
        "districtid": 73
    },
    {
        "label": "Aarughat",
        "value": 508,
        "extent": [
            9433396.896990478,
            3253929.5346620353,
            9459058.168562392,
            3274115.6925439606
        ],
        "districtid": 23
    },
    {
        "label": "Aathabis",
        "value": 617,
        "extent": [
            9062522.963148717,
            3364437.1905631,
            9081675.30989109,
            3392952.680554647
        ],
        "districtid": 14
    },
    {
        "label": "Aathbiskot",
        "value": 567,
        "extent": [
            9158896.367852962,
            3337555.4392888257,
            9206142.356454175,
            3374626.1105913958
        ],
        "districtid": 61
    },
    {
        "label": "Aathrai",
        "value": 80,
        "extent": [
            9746335.23714364,
            3139644.2471552053,
            9768456.096983721,
            3159371.7715659486
        ],
        "districtid": 76
    },
    {
        "label": "Aathrai Tribeni",
        "value": 1,
        "extent": [
            9745139.510400526,
            3157008.6904822397,
            9762288.612222489,
            3169924.6398351667
        ],
        "districtid": 75
    },
    {
        "label": "Aaurahi",
        "value": 140,
        "extent": [
            9571414.78542169,
            3083809.5879836516,
            9579310.656190252,
            3090368.413023838
        ],
        "districtid": 19
    },
    {
        "label": "Adanchuli",
        "value": 658,
        "extent": [
            9102592.53326868,
            3454711.3989002043,
            9121953.932460347,
            3475552.2233170425
        ],
        "districtid": 25
    },
    {
        "label": "Adarshkotwal",
        "value": 481,
        "extent": [
            9472108.158084786,
            3111347.1628638613,
            9482109.090502396,
            3122167.4252173034
        ],
        "districtid": 8
    },
    {
        "label": "Adharsha",
        "value": 679,
        "extent": [
            8990533.057139836,
            3411797.193086457,
            9012803.982894111,
            3428800.963105413
        ],
        "districtid": 22
    },
    {
        "label": "Agnisair Krishna Savaran",
        "value": 179,
        "extent": [
            9655981.479683548,
            3070603.0718789245,
            9667314.518467195,
            3087818.1329363384
        ],
        "districtid": 65
    },
    {
        "label": "Ainselukhark",
        "value": 173,
        "extent": [
            9648967.460757071,
            3161966.304986903,
            9668112.18518415,
            3178573.0832473715
        ],
        "districtid": 37
    },
    {
        "label": "Ajaymeru",
        "value": 760,
        "extent": [
            8950393.36791503,
            3415057.5705333333,
            8974928.289444096,
            3429017.9686753196
        ],
        "districtid": 13
    },
    {
        "label": "Ajirkot",
        "value": 509,
        "extent": [
            9418486.454228591,
            3262696.4397523836,
            9432827.233072532,
            3294553.5475406987
        ],
        "districtid": 23
    },
    {
        "label": "Alital",
        "value": 761,
        "extent": [
            8952915.446033478,
            3374780.6470265985,
            8974534.280511431,
            3405786.761170591
        ],
        "districtid": 13
    },
    {
        "label": "Amargadhi",
        "value": 762,
        "extent": [
            8958911.978326954,
            3403995.8813242447,
            8980192.051621966,
            3425359.934547021
        ],
        "districtid": 13
    },
    {
        "label": "Anbukhaireni",
        "value": 302,
        "extent": [
            9395605.736016763,
            3225722.315303982,
            9413036.052683508,
            3241876.3252852974
        ],
        "districtid": 74
    },
    {
        "label": "Annapurna",
        "value": 395,
        "extent": [
            9317497.336382011,
            3281131.466318251,
            9345164.14846972,
            3326527.0909326095
        ],
        "districtid": 35
    },
    {
        "label": "Annapurna",
        "value": 409,
        "extent": [
            9303260.299638757,
            3292927.292310973,
            9336529.363840256,
            3336652.416407009
        ],
        "districtid": 46
    },
    {
        "label": "Apihimal",
        "value": 742,
        "extent": [
            8985863.156129934,
            3470241.2301550843,
            9024772.8903367,
            3502650.5709633124
        ],
        "districtid": 16
    },
    {
        "label": "Arjunchaupari",
        "value": 341,
        "extent": [
            9317832.42218548,
            3256434.5642342414,
            9330626.193577757,
            3267773.2062082645
        ],
        "districtid": 73
    },
    {
        "label": "Arjundhara",
        "value": 9,
        "extent": [
            9787927.96733276,
            3078639.907331395,
            9800877.532799121,
            3097243.3957360242
        ],
        "districtid": 28
    },
    {
        "label": "Arnama",
        "value": 267,
        "extent": [
            9602425.604715081,
            3078017.7776195193,
            9609253.82377028,
            3091800.7855563373
        ],
        "districtid": 69
    },
    {
        "label": "Arun",
        "value": 89,
        "extent": [
            9697411.9807137,
            3136741.9013893553,
            9715464.218066154,
            3156762.7384417388
        ],
        "districtid": 11
    },
    {
        "label": "Aurahi",
        "value": 158,
        "extent": [
            9546054.975758953,
            3100939.7664054814,
            9555954.487704141,
            3112159.273508014
        ],
        "districtid": 40
    },
    {
        "label": "Aurahi",
        "value": 268,
        "extent": [
            9602473.340233015,
            3075234.1714243656,
            9612273.807353433,
            3084136.894980621
        ],
        "districtid": 69
    },
    {
        "label": "Ayirabati",
        "value": 548,
        "extent": [
            9217927.937180327,
            3238874.079596642,
            9241485.08054293,
            3256083.526150459
        ],
        "districtid": 55
    },
    {
        "label": "Babai",
        "value": 583,
        "extent": [
            9119381.678618854,
            3258683.023356085,
            9147122.40252531,
            3284712.939240922
        ],
        "districtid": 15
    },
    {
        "label": "Badhaiyatal",
        "value": 601,
        "extent": [
            9059882.309305904,
            3257657.188967612,
            9079436.874133652,
            3278579.567613227
        ],
        "districtid": 9
    },
    {
        "label": "Badigad",
        "value": 465,
        "extent": [
            9249920.933544008,
            3272632.582180231,
            9277045.075418431,
            3293045.297602509
        ],
        "districtid": 3
    },
    {
        "label": "Badikedar",
        "value": 680,
        "extent": [
            8987432.899162613,
            3366819.353731666,
            9017260.012512267,
            3391968.203678345
        ],
        "districtid": 22
    },
    {
        "label": "Badimalika",
        "value": 665,
        "extent": [
            9059493.080618331,
            3419768.223731415,
            9082824.753896186,
            3443774.5598590877
        ],
        "districtid": 6
    },
    {
        "label": "Bagchaur",
        "value": 573,
        "extent": [
            9154307.212196661,
            3299946.784397729,
            9174750.27996948,
            3317341.314087103
        ],
        "districtid": 63
    },
    {
        "label": "Baglung",
        "value": 466,
        "extent": [
            9299085.865998201,
            3272183.3131793523,
            9314600.631763304,
            3289003.7801323845
        ],
        "districtid": 3
    },
    {
        "label": "Bagmati",
        "value": 113,
        "extent": [
            9493137.94218876,
            3143698.26992602,
            9518961.096981665,
            3177165.9743936122
        ],
        "districtid": 41
    },
    {
        "label": "Bagmati",
        "value": 198,
        "extent": [
            9506939.93846867,
            3124429.102126304,
            9521545.364395177,
            3142792.44111215
        ],
        "districtid": 66
    },
    {
        "label": "Bagmati",
        "value": 318,
        "extent": [
            9487921.493692886,
            3174524.950646938,
            9506813.751773799,
            3193913.3173929006
        ],
        "districtid": 38
    },
    {
        "label": "Bagnaskali",
        "value": 219,
        "extent": [
            9298246.622285219,
            3226366.8640295304,
            9311361.25921547,
            3241787.5353114866
        ],
        "districtid": 51
    },
    {
        "label": "Bahudaramai",
        "value": 484,
        "extent": [
            9438561.704029225,
            3127997.4783738246,
            9446159.420459779,
            3138804.4306020155
        ],
        "districtid": 54
    },
    {
        "label": "Baijanath",
        "value": 593,
        "extent": [
            9074540.946995586,
            3267128.6671718056,
            9098862.688365372,
            3291631.416106468
        ],
        "districtid": 7
    },
    {
        "label": "Baiteshwor",
        "value": 360,
        "extent": [
            9581806.926914314,
            3195885.048403184,
            9593938.194723096,
            3210223.3095511957
        ],
        "districtid": 20
    },
    {
        "label": "Bakaiya",
        "value": 114,
        "extent": [
            9475263.742889032,
            3149402.0207329127,
            9506704.866380075,
            3182944.7166853277
        ],
        "districtid": 41
    },
    {
        "label": "Balan Bihul",
        "value": 180,
        "extent": [
            9627557.422472984,
            3065494.2947069127,
            9634786.907959986,
            3075461.689060365
        ],
        "districtid": 65
    },
    {
        "label": "Balara",
        "value": 199,
        "extent": [
            9497971.301083954,
            3091207.1253686342,
            9509539.467712387,
            3102650.507394556
        ],
        "districtid": 66
    },
    {
        "label": "Balefi",
        "value": 362,
        "extent": [
            9546963.07666496,
            3215426.379070369,
            9559793.894758767,
            3228753.480956431
        ],
        "districtid": 68
    },
    {
        "label": "Balwa",
        "value": 159,
        "extent": [
            9549168.198231068,
            3087712.10906783,
            9556359.986766785,
            3102396.0095219407
        ],
        "districtid": 40
    },
    {
        "label": "Bandipur",
        "value": 303,
        "extent": [
            9388869.292379444,
            3229123.6178511693,
            9401806.489609925,
            3248277.827610954
        ],
        "districtid": 74
    },
    {
        "label": "Banepa",
        "value": 374,
        "extent": [
            9513378.705728699,
            3198763.1303056506,
            9524909.142263854,
            3210479.269608106
        ],
        "districtid": 30
    },
    {
        "label": "Banfikot",
        "value": 568,
        "extent": [
            9172640.951593684,
            3330198.4070821186,
            9196752.267756322,
            3347670.057858855
        ],
        "districtid": 61
    },
    {
        "label": "Bangad Kupinde",
        "value": 574,
        "extent": [
            9123777.928507015,
            3292021.7031116667,
            9144299.637096085,
            3330489.4443741166
        ],
        "districtid": 63
    },
    {
        "label": "Banganga",
        "value": 532,
        "extent": [
            9246999.961074382,
            3196572.0479346416,
            9265298.173087304,
            3221635.5250225808
        ],
        "districtid": 34
    },
    {
        "label": "Banglachuli",
        "value": 584,
        "extent": [
            9186236.538117724,
            3235806.6252804166,
            9214537.647473047,
            3260809.836298528
        ],
        "districtid": 15
    },
    {
        "label": "Bannigadhi Jayagadh",
        "value": 705,
        "extent": [
            9043738.236965077,
            3396113.820559302,
            9057314.295298021,
            3404436.870993842
        ],
        "districtid": 1
    },
    {
        "label": "Bansagadhi",
        "value": 602,
        "extent": [
            9062785.04908584,
            3275411.8162535005,
            9089605.708935328,
            3289550.144971013
        ],
        "districtid": 9
    },
    {
        "label": "Bansagadhi",
        "value": 603,
        "extent": [
            9091855.481447391,
            3288491.0755865383,
            9102215.590076013,
            3300072.654564984
        ],
        "districtid": 9
    },
    {
        "label": "Baragadhi",
        "value": 482,
        "extent": [
            9472235.432474993,
            3117315.750865991,
            9483007.290647613,
            3127142.8981407736
        ],
        "districtid": 8
    },
    {
        "label": "Barah",
        "value": 60,
        "extent": [
            9686319.75965454,
            3077138.4955703965,
            9710650.739841884,
            3108257.003286481
        ],
        "districtid": 71
    },
    {
        "label": "Barahapokhari",
        "value": 134,
        "extent": [
            9657501.826336233,
            3107511.8485094043,
            9675522.603651248,
            3124576.831032432
        ],
        "districtid": 37
    },
    {
        "label": "Barahathawa",
        "value": 200,
        "extent": [
            9505109.729009861,
            3114064.2399786124,
            9521572.37022661,
            3128400.991829872
        ],
        "districtid": 66
    },
    {
        "label": "Barahtal",
        "value": 530,
        "extent": [
            9051401.645439696,
            3313373.6473203185,
            9085469.674074523,
            3350028.8003961705
        ],
        "districtid": 72
    },
    {
        "label": "Barbardiya",
        "value": 604,
        "extent": [
            9049179.833665477,
            3276789.856903752,
            9071245.054462777,
            3302618.1663904465
        ],
        "districtid": 9
    },
    {
        "label": "Bardaghat",
        "value": 229,
        "extent": [
            9321299.447094753,
            3182613.920276419,
            9337776.429594215,
            3207103.918386468
        ],
        "districtid": 48
    },
    {
        "label": "Bardagoriya",
        "value": 715,
        "extent": [
            9016198.970967526,
            3326467.9559416003,
            9025748.684795408,
            3345436.80108769
        ],
        "districtid": 31
    },
    {
        "label": "Bardibas",
        "value": 160,
        "extent": [
            9544584.152550973,
            3107914.066165123,
            9567374.756086543,
            3144521.5518754693
        ],
        "districtid": 40
    },
    {
        "label": "Bardiya National Park",
        "value": 529,
        "extent": [
            9038892.96014092,
            3285093.581649468,
            9096351.140233077,
            3334303.9651311897
        ],
        "districtid": 9
    },
    {
        "label": "Barekot",
        "value": 628,
        "extent": [
            9141262.867110407,
            3355878.1322441306,
            9174029.747881515,
            3391876.8013306144
        ],
        "districtid": 27
    },
    {
        "label": "Bareng",
        "value": 467,
        "extent": [
            9282911.890120817,
            3263258.3558592536,
            9301385.842292842,
            3271923.9031148297
        ],
        "districtid": 3
    },
    {
        "label": "Barhabise",
        "value": 363,
        "extent": [
            9553473.010379102,
            3218874.909048057,
            9576371.530614397,
            3238662.6880306574
        ],
        "districtid": 68
    },
    {
        "label": "Barhadashi",
        "value": 10,
        "extent": [
            9783540.13385914,
            3054514.2184594623,
            9793013.140175842,
            3074779.9852119815
        ],
        "districtid": 28
    },
    {
        "label": "Barhagaun Muktikhsetra",
        "value": 404,
        "extent": [
            9292900.426676529,
            3344014.169922605,
            9356592.716474373,
            3381216.863625315
        ],
        "districtid": 45
    },
    {
        "label": "Bariyarpatti",
        "value": 269,
        "extent": [
            9609858.47900571,
            3072718.24630699,
            9619787.301086014,
            3082288.432232373
        ],
        "districtid": 69
    },
    {
        "label": "Barju",
        "value": 61,
        "extent": [
            9702242.5782743,
            3049104.8675700994,
            9712407.438873459,
            3063408.0993893184
        ],
        "districtid": 71
    },
    {
        "label": "Basbariya",
        "value": 284,
        "extent": [
            9505128.218077354,
            3110699.942896093,
            9517551.038485255,
            3117755.8879927215
        ],
        "districtid": 66
    },
    {
        "label": "Bateshwor",
        "value": 141,
        "extent": [
            9561785.17820783,
            3102444.109822798,
            9567379.332351385,
            3115302.4370529265
        ],
        "districtid": 19
    },
    {
        "label": "Baudhimai",
        "value": 202,
        "extent": [
            9480312.019273613,
            3106395.4554966725,
            9492490.133203665,
            3113727.6259498144
        ],
        "districtid": 58
    },
    {
        "label": "Bedkot",
        "value": 728,
        "extent": [
            8927896.242512742,
            3364147.5586085976,
            8943988.65258102,
            3383090.136855421
        ],
        "districtid": 33
    },
    {
        "label": "Belaka",
        "value": 177,
        "extent": [
            9676398.55781533,
            3087201.5033142883,
            9703556.884622304,
            3114415.0098961317
        ],
        "districtid": 77
    },
    {
        "label": "Belauri",
        "value": 729,
        "extent": [
            8934077.368540032,
            3328421.955331741,
            8953207.21219963,
            3346735.4574026302
        ],
        "districtid": 33
    },
    {
        "label": "Belbari",
        "value": 43,
        "extent": [
            9727544.747209067,
            3066346.743164816,
            9739722.436847847,
            3088358.3173590344
        ],
        "districtid": 43
    },
    {
        "label": "Beldandi",
        "value": 730,
        "extent": [
            8929873.701749587,
            3343081.507704466,
            8940588.09668776,
            3350641.6985658105
        ],
        "districtid": 33
    },
    {
        "label": "Belhi Chapena",
        "value": 181,
        "extent": [
            9643156.835797347,
            3054802.784079912,
            9652368.530522356,
            3069124.9838263188
        ],
        "districtid": 65
    },
    {
        "label": "Belkotgadhi",
        "value": 431,
        "extent": [
            9463483.029029265,
            3218824.7291654423,
            9484952.967902144,
            3235239.976960525
        ],
        "districtid": 49
    },
    {
        "label": "Beni",
        "value": 410,
        "extent": [
            9292880.994634874,
            3286609.1222310816,
            9306474.891574556,
            3301106.2865468464
        ],
        "districtid": 46
    },
    {
        "label": "Benighat Rorang",
        "value": 418,
        "extent": [
            9419655.066871163,
            3207268.9310671184,
            9451241.34171774,
            3226957.253608533
        ],
        "districtid": 17
    },
    {
        "label": "Besishahar",
        "value": 294,
        "extent": [
            9381874.685162205,
            3268119.8112270315,
            9401879.25085345,
            3285114.910955232
        ],
        "districtid": 39
    },
    {
        "label": "Bethanchowk",
        "value": 375,
        "extent": [
            9507417.123400379,
            3178985.976941894,
            9527447.858231837,
            3194495.6603493835
        ],
        "districtid": 30
    },
    {
        "label": "Bhadrapur",
        "value": 11,
        "extent": [
            9799563.39237136,
            3052969.9061917304,
            9808516.180074751,
            3075699.862341346
        ],
        "districtid": 28
    },
    {
        "label": "Bhagawanpur",
        "value": 270,
        "extent": [
            9621357.161988996,
            3067335.027943187,
            9629731.444376308,
            3076226.3812695015
        ],
        "districtid": 69
    },
    {
        "label": "Bhagawatimai",
        "value": 618,
        "extent": [
            9097918.441812636,
            3339888.9304837263,
            9118433.40419465,
            3360680.804426227
        ],
        "districtid": 14
    },
    {
        "label": "Bhageshwar",
        "value": 763,
        "extent": [
            8937905.349979892,
            3401461.374294876,
            8967515.31252892,
            3421626.7684796015
        ],
        "districtid": 13
    },
    {
        "label": "Bhairabi",
        "value": 619,
        "extent": [
            9081542.229166118,
            3355276.8936922816,
            9095200.515661968,
            3381990.774963796
        ],
        "districtid": 14
    },
    {
        "label": "Bhajani",
        "value": 716,
        "extent": [
            9004742.122954333,
            3303844.7204686766,
            9022129.453002017,
            3325591.2227567304
        ],
        "districtid": 31
    },
    {
        "label": "Bhaktapur",
        "value": 378,
        "extent": [
            9506672.271466231,
            3206658.644471244,
            9512117.201546554,
            3210137.8492646925
        ],
        "districtid": 10
    },
    {
        "label": "Bhangaha",
        "value": 161,
        "extent": [
            9552980.037346113,
            3097837.289966659,
            9564538.399296766,
            3112105.5888648583
        ],
        "districtid": 40
    },
    {
        "label": "Bhanu",
        "value": 304,
        "extent": [
            9385386.323513225,
            3242937.546787028,
            9403993.277545162,
            3265339.937740477
        ],
        "districtid": 74
    },
    {
        "label": "Bharatpur",
        "value": 500,
        "extent": [
            9368703.021722374,
            3192520.76331801,
            9409371.171250844,
            3226845.762488361
        ],
        "districtid": 12
    },
    {
        "label": "Bheri",
        "value": 629,
        "extent": [
            9135767.602645935,
            3326259.987075341,
            9159839.341091182,
            3351211.8622644856
        ],
        "districtid": 27
    },
    {
        "label": "Bheriganga",
        "value": 609,
        "extent": [
            9075792.005478308,
            3295690.46361166,
            9109931.48081407,
            3320922.890241469
        ],
        "districtid": 72
    },
    {
        "label": "Bhimad",
        "value": 305,
        "extent": [
            9347152.597807461,
            3236688.750877981,
            9369012.804305628,
            3251925.01267734
        ],
        "districtid": 74
    },
    {
        "label": "Bhimdatta",
        "value": 731,
        "extent": [
            8917082.621517329,
            3362308.538428072,
            8932522.875993477,
            3393124.404562209
        ],
        "districtid": 33
    },
    {
        "label": "Bhimeshwor",
        "value": 361,
        "extent": [
            9566138.647225643,
            3200272.771106117,
            9585280.968332492,
            3216884.9281496834
        ],
        "districtid": 20
    },
    {
        "label": "Bhimphedi",
        "value": 115,
        "extent": [
            9460536.75030664,
            3180212.1240961575,
            9491260.145704739,
            3200165.6114258273
        ],
        "districtid": 41
    },
    {
        "label": "Bhimsen",
        "value": 510,
        "extent": [
            9422961.978283294,
            3241511.7584520997,
            9441390.277554123,
            3256844.635680502
        ],
        "districtid": 23
    },
    {
        "label": "Bhirkot",
        "value": 342,
        "extent": [
            9316725.266230445,
            3248765.937580361,
            9336198.965453189,
            3259824.3607732514
        ],
        "districtid": 73
    },
    {
        "label": "Bhojpur",
        "value": 90,
        "extent": [
            9683009.700712802,
            3135431.545343183,
            9700145.29817521,
            3158581.392159941
        ],
        "districtid": 11
    },
    {
        "label": "Bhokraha Narsingh",
        "value": 62,
        "extent": [
            9692603.856768992,
            3063824.0046197316,
            9699679.515227139,
            3081412.847216995
        ],
        "districtid": 71
    },
    {
        "label": "Bhotekoshi",
        "value": 364,
        "extent": [
            9554531.813913718,
            3225393.5656590164,
            9580704.089308731,
            3255705.2220600904
        ],
        "districtid": 68
    },
    {
        "label": "Bhotkhola",
        "value": 84,
        "extent": [
            9704020.573036794,
            3202505.5427810634,
            9760187.067399608,
            3232217.8963943864
        ],
        "districtid": 64
    },
    {
        "label": "Bhume",
        "value": 752,
        "extent": [
            9187079.48549705,
            3309043.9932522783,
            9229721.39308074,
            3332153.5782373208
        ],
        "districtid": 60
    },
    {
        "label": "Bhumekasthan",
        "value": 542,
        "extent": [
            9234205.441667262,
            3237144.6520915683,
            9253861.928629657,
            3260277.341945069
        ],
        "districtid": 2
    },
    {
        "label": "Bhumlu",
        "value": 376,
        "extent": [
            9534874.849661548,
            3195303.382590667,
            9553634.395719385,
            3208721.9338036943
        ],
        "districtid": 30
    },
    {
        "label": "Bideha",
        "value": 142,
        "extent": [
            9572091.459894847,
            3078968.900033546,
            9584982.628492748,
            3088146.5631292555
        ],
        "districtid": 19
    },
    {
        "label": "Bidur",
        "value": 432,
        "extent": [
            9469034.550559793,
            3230419.6361222314,
            9487616.67420401,
            3247209.978994655
        ],
        "districtid": 49
    },
    {
        "label": "Bigu",
        "value": 287,
        "extent": [
            9573742.899986466,
            3215672.519990661,
            9606856.95122135,
            3270941.6729290728
        ],
        "districtid": 20
    },
    {
        "label": "Bihadi",
        "value": 458,
        "extent": [
            9301750.75945279,
            3250247.4698872506,
            9310065.742678812,
            3263127.0604220508
        ],
        "districtid": 53
    },
    {
        "label": "Bijayanagar",
        "value": 533,
        "extent": [
            9205675.526204813,
            3192316.294084205,
            9221016.485725855,
            3220548.7483168487
        ],
        "districtid": 34
    },
    {
        "label": "Binayee Tribeni",
        "value": 770,
        "extent": [
            9314876.205264414,
            3189576.7624415914,
            9342594.226424871,
            3215711.103286626
        ],
        "districtid": 47
    },
    {
        "label": "Binayee Tribeni",
        "value": 769,
        "extent": [
            9336878.784186397,
            3178269.538017626,
            9344657.453946363,
            3186027.713751879
        ],
        "districtid": 47
    },
    {
        "label": "Bindabasini",
        "value": 485,
        "extent": [
            9435309.95005013,
            3122945.0399230015,
            9442017.491781639,
            3133175.794329337
        ],
        "districtid": 54
    },
    {
        "label": "Biratnagar",
        "value": 44,
        "extent": [
            9711342.517751344,
            3045305.6831233697,
            9720894.564773444,
            3062649.401774131
        ],
        "districtid": 43
    },
    {
        "label": "Birendranagar",
        "value": 610,
        "extent": [
            9076217.448934384,
            3312868.3516968335,
            9103291.343364654,
            3336524.1831699754
        ],
        "districtid": 72
    },
    {
        "label": "Birgunj",
        "value": 486,
        "extent": [
            9440970.243704654,
            3121439.9382559625,
            9458202.029122453,
            3152562.0530152665
        ],
        "districtid": 54
    },
    {
        "label": "Birtamod",
        "value": 12,
        "extent": [
            9789452.219711803,
            3067830.6900261273,
            9801638.272033177,
            3080498.6104028304
        ],
        "districtid": 28
    },
    {
        "label": "Biruwa",
        "value": 387,
        "extent": [
            9333826.844605261,
            3237797.609090781,
            9344851.798976513,
            3258448.845692856
        ],
        "districtid": 73
    },
    {
        "label": "Bishnu",
        "value": 285,
        "extent": [
            9510601.908737935,
            3096171.0097911237,
            9518302.804966884,
            3105783.637989605
        ],
        "districtid": 66
    },
    {
        "label": "Bishnupur",
        "value": 271,
        "extent": [
            9596854.889914256,
            3086306.5831132354,
            9606241.486824883,
            3092285.206900064
        ],
        "districtid": 69
    },
    {
        "label": "Bishnupur",
        "value": 182,
        "extent": [
            9649548.585060867,
            3058755.1708435914,
            9658355.648794986,
            3068827.591884737
        ],
        "districtid": 65
    },
    {
        "label": "Bishrampur",
        "value": 240,
        "extent": [
            9447251.039546654,
            3118956.1672257013,
            9456138.991078023,
            3126272.3249627627
        ],
        "districtid": 8
    },
    {
        "label": "Bithadchir",
        "value": 695,
        "extent": [
            8988599.445554225,
            3431945.0487135113,
            9006920.00704109,
            3448142.3493426386
        ],
        "districtid": 5
    },
    {
        "label": "Bode Barsain",
        "value": 183,
        "extent": [
            9633237.631780233,
            3060456.7466143076,
            9641172.28587019,
            3075406.4989550463
        ],
        "districtid": 65
    },
    {
        "label": "Bogtan",
        "value": 681,
        "extent": [
            9004067.023393748,
            3367846.631713056,
            9033581.130246826,
            3396292.222386084
        ],
        "districtid": 22
    },
    {
        "label": "Bramhapuri",
        "value": 286,
        "extent": [
            9525960.670184666,
            3104391.03308068,
            9535576.238464199,
            3114779.6514472505
        ],
        "districtid": 66
    },
    {
        "label": "Brindaban",
        "value": 203,
        "extent": [
            9493184.175812628,
            3119919.9668146907,
            9512328.535295898,
            3138128.9610316507
        ],
        "districtid": 58
    },
    {
        "label": "Buddhabhumi",
        "value": 534,
        "extent": [
            9228884.6458423,
            3191995.635700265,
            9252649.779924842,
            3226375.448160197
        ],
        "districtid": 34
    },
    {
        "label": "Buddhashanti",
        "value": 13,
        "extent": [
            9795288.05115267,
            3083468.682858704,
            9809846.865138296,
            3098692.9258150146
        ],
        "districtid": 28
    },
    {
        "label": "Budhanilakantha",
        "value": 419,
        "extent": [
            9499247.132500922,
            3213974.382879981,
            9505413.98385548,
            3225539.5106960097
        ],
        "districtid": 36
    },
    {
        "label": "Budhiganga",
        "value": 666,
        "extent": [
            9045039.870481728,
            3414087.5675052623,
            9060717.870067509,
            3429166.93752229
        ],
        "districtid": 6
    },
    {
        "label": "Budhiganga",
        "value": 45,
        "extent": [
            9712157.70147044,
            3061101.5881654816,
            9724148.929771334,
            3076681.472888524
        ],
        "districtid": 43
    },
    {
        "label": "Budhinanda",
        "value": 667,
        "extent": [
            9076591.977728104,
            3428405.844102707,
            9096686.130484179,
            3460115.9386161836
        ],
        "districtid": 6
    },
    {
        "label": "Bulingtar",
        "value": 771,
        "extent": [
            9362172.35719721,
            3217865.55536773,
            9384859.059104798,
            3231356.605145326
        ],
        "districtid": 47
    },
    {
        "label": "Bungal",
        "value": 696,
        "extent": [
            8990369.712377163,
            3444977.916789183,
            9028410.391488243,
            3482383.3991333693
        ],
        "districtid": 5
    },
    {
        "label": "Bungdikali",
        "value": 772,
        "extent": [
            9350609.536643704,
            3219235.012393701,
            9364302.84083938,
            3232568.3977792095
        ],
        "districtid": 47
    },
    {
        "label": "Butwal",
        "value": 258,
        "extent": [
            9279739.440669503,
            3200590.8150781933,
            9295633.780451227,
            3217342.7640135316
        ],
        "districtid": 62
    },
    {
        "label": "Byas",
        "value": 306,
        "extent": [
            9370157.62575672,
            3233541.790868314,
            9391865.09308201,
            3264627.588054119
        ],
        "districtid": 74
    },
    {
        "label": "Byas",
        "value": 743,
        "extent": [
            8964050.311979057,
            3486669.5868977895,
            9028971.315764634,
            3564491.2682027435
        ],
        "districtid": 16
    },
    {
        "label": "Chabispathivera",
        "value": 697,
        "extent": [
            9015347.43433319,
            3437992.0000900235,
            9031509.125050038,
            3456281.2413860033
        ],
        "districtid": 5
    },
    {
        "label": "Chainpur",
        "value": 85,
        "extent": [
            9706727.07106221,
            3149885.3641988547,
            9742299.700336488,
            3174308.3534723804
        ],
        "districtid": 64
    },
    {
        "label": "Chakraghatta",
        "value": 307,
        "extent": [
            9515373.700712053,
            3107601.134976443,
            9522694.405497884,
            3114885.632796325
        ],
        "districtid": 66
    },
    {
        "label": "Chame",
        "value": 400,
        "extent": [
            9371603.874107307,
            3308458.6194114536,
            9385826.27308627,
            3321752.0105860564
        ],
        "districtid": 42
    },
    {
        "label": "Champadevi",
        "value": 165,
        "extent": [
            9596125.666621365,
            3153153.383986004,
            9614595.270467868,
            3170984.419402858
        ],
        "districtid": 50
    },
    {
        "label": "Chamunda Bindrasaini",
        "value": 620,
        "extent": [
            9070075.485373152,
            3358890.8983155824,
            9086613.396498865,
            3375932.1215654365
        ],
        "districtid": 14
    },
    {
        "label": "Chandannath",
        "value": 643,
        "extent": [
            9138138.946103012,
            3406523.5871995743,
            9152357.547156254,
            3421967.72381723
        ],
        "districtid": 29
    },
    {
        "label": "Chandragiri",
        "value": 420,
        "extent": [
            9483143.457719602,
            3204325.0031746565,
            9493069.63067134,
            3214570.65103684
        ],
        "districtid": 36
    },
    {
        "label": "Chandrakot",
        "value": 476,
        "extent": [
            9276075.567113614,
            3254858.4487595414,
            9296175.841999503,
            3270104.071901035
        ],
        "districtid": 24
    },
    {
        "label": "Chandranagar",
        "value": 308,
        "extent": [
            9524600.581138007,
            3110380.7557117487,
            9533490.296480464,
            3120453.555361074
        ],
        "districtid": 66
    },
    {
        "label": "Chandrapur",
        "value": 204,
        "extent": [
            9493795.497733552,
            3126305.143378944,
            9518244.034694832,
            3152460.535348864
        ],
        "districtid": 58
    },
    {
        "label": "Changunarayan",
        "value": 379,
        "extent": [
            9506241.002265282,
            3205671.2120768493,
            9520601.8418823,
            3214803.4548961413
        ],
        "districtid": 10
    },
    {
        "label": "Chankheli",
        "value": 659,
        "extent": [
            9127370.846927963,
            3456686.5021327254,
            9183581.404254993,
            3513237.2461460284
        ],
        "districtid": 25
    },
    {
        "label": "Chapakot",
        "value": 388,
        "extent": [
            9323027.179278405,
            3232360.7864622194,
            9346552.905397246,
            3246357.289339625
        ],
        "districtid": 73
    },
    {
        "label": "Chatrakot",
        "value": 477,
        "extent": [
            9270512.308281653,
            3238986.496640742,
            9285364.3120006,
            3255514.8621646967
        ],
        "districtid": 24
    },
    {
        "label": "Chaubise",
        "value": 73,
        "extent": [
            9729497.972068593,
            3105608.0996372323,
            9749360.470569352,
            3121665.242713548
        ],
        "districtid": 18
    },
    {
        "label": "Chaudandigadhi",
        "value": 102,
        "extent": [
            9659058.599559668,
            3084858.188632179,
            9683951.926533574,
            3111939.6699642697
        ],
        "districtid": 77
    },
    {
        "label": "Chaukune",
        "value": 611,
        "extent": [
            9014756.298571195,
            3342659.3464492997,
            9056114.026475433,
            3372880.2606183523
        ],
        "districtid": 72
    },
    {
        "label": "Chaurideurali",
        "value": 377,
        "extent": [
            9543800.336935464,
            3186111.064992449,
            9560215.15761464,
            3204054.947168872
        ],
        "districtid": 30
    },
    {
        "label": "Chaurjahari",
        "value": 569,
        "extent": [
            9148749.898465645,
            3322206.9410486305,
            9167856.1374488,
            3336438.2868913184
        ],
        "districtid": 61
    },
    {
        "label": "Chaurpati",
        "value": 706,
        "extent": [
            9019826.189379672,
            3388291.33360292,
            9040970.17700324,
            3414498.5156576987
        ],
        "districtid": 1
    },
    {
        "label": "Chautara SangachokGadhi",
        "value": 365,
        "extent": [
            9536678.02699633,
            3203867.0285166027,
            9548959.398178402,
            3231438.4537763647
        ],
        "districtid": 68
    },
    {
        "label": "Chharka Tangsong",
        "value": 635,
        "extent": [
            9242869.698343826,
            3340298.385522685,
            9315250.240094751,
            3405896.3654383398
        ],
        "districtid": 21
    },
    {
        "label": "Chhathar",
        "value": 81,
        "extent": [
            9728913.610498296,
            3119467.1491208943,
            9747460.86806752,
            3136134.190446281
        ],
        "districtid": 76
    },
    {
        "label": "Chhathar Jorpati",
        "value": 74,
        "extent": [
            9719279.158713972,
            3116542.0940268757,
            9733989.19077726,
            3136018.166890015
        ],
        "districtid": 18
    },
    {
        "label": "Chhatradev",
        "value": 543,
        "extent": [
            9258442.066737821,
            3240431.314504612,
            9273207.072514126,
            3260027.014454369
        ],
        "districtid": 2
    },
    {
        "label": "Chhatreshwori",
        "value": 575,
        "extent": [
            9148382.635426223,
            3285030.410226679,
            9170888.117799893,
            3303305.9038125454
        ],
        "districtid": 63
    },
    {
        "label": "Chhayanath Rara",
        "value": 691,
        "extent": [
            9127850.000853201,
            3427433.1075306092,
            9163473.86137695,
            3460533.4618203244
        ],
        "districtid": 44
    },
    {
        "label": "Chhedagad",
        "value": 630,
        "extent": [
            9114852.70673834,
            3328666.6782296104,
            9146011.089398991,
            3359468.8524757894
        ],
        "districtid": 27
    },
    {
        "label": "Chhededaha",
        "value": 668,
        "extent": [
            9038053.177360231,
            3418610.522161524,
            9063310.239881547,
            3434306.2833883776
        ],
        "districtid": 6
    },
    {
        "label": "Chhinnamasta",
        "value": 184,
        "extent": [
            9650839.723777048,
            3051480.3164761886,
            9658650.067564316,
            3062171.735709384
        ],
        "districtid": 65
    },
    {
        "label": "Chhipaharmai",
        "value": 487,
        "extent": [
            9422372.488705376,
            3126844.6406860473,
            9428967.171265956,
            3136049.700804243
        ],
        "districtid": 54
    },
    {
        "label": "Chhireshwornath",
        "value": 143,
        "extent": [
            9565152.111722006,
            3096936.6594797396,
            9574492.841581462,
            3111917.0428130305
        ],
        "districtid": 19
    },
    {
        "label": "Chichila",
        "value": 86,
        "extent": [
            9700874.140764266,
            3178233.7143609724,
            9717866.679950489,
            3189600.7617850634
        ],
        "districtid": 64
    },
    {
        "label": "Chingad",
        "value": 612,
        "extent": [
            9099879.755103672,
            3316046.889838502,
            9119142.484510558,
            3340567.9821040765
        ],
        "districtid": 72
    },
    {
        "label": "Chisankhugadhi",
        "value": 166,
        "extent": [
            9633264.05473004,
            3154771.7312120316,
            9649845.104206007,
            3171900.7364070504
        ],
        "districtid": 50
    },
    {
        "label": "Chitawan National Park",
        "value": 507,
        "extent": [
            9341782.056197345,
            3172774.8938593464,
            9430222.07223115,
            3209892.3844200904
        ],
        "districtid": 12
    },
    {
        "label": "Chitawan National Park",
        "value": 751,
        "extent": [
            9336981.693857852,
            3180864.973628517,
            9386896.56254454,
            3209932.4427932464
        ],
        "districtid": 47
    },
    {
        "label": "Chitawan National Park",
        "value": 499,
        "extent": [
            9410094.84820609,
            3166376.050264837,
            9431960.93757306,
            3181450.368774626
        ],
        "districtid": 54
    },
    {
        "label": "Chitawan National Park",
        "value": 201,
        "extent": [
            9424827.784001382,
            3177173.6120997192,
            9433271.41984457,
            3194290.88831286
        ],
        "districtid": 41
    },
    {
        "label": "Chulachuli",
        "value": 36,
        "extent": [
            9751531.126602191,
            3081626.0979167297,
            9775851.64718632,
            3106896.943019218
        ],
        "districtid": 26
    },
    {
        "label": "Chum Nubri",
        "value": 511,
        "extent": [
            9404464.509457529,
            3290667.1399808307,
            9484186.626891747,
            3344136.463879244
        ],
        "districtid": 23
    },
    {
        "label": "Chure",
        "value": 717,
        "extent": [
            8963162.43893878,
            3348455.889271122,
            9001558.620235033,
            3384313.9801411857
        ],
        "districtid": 31
    },
    {
        "label": "Dakneshwori",
        "value": 185,
        "extent": [
            9637248.198546758,
            3058069.1666178503,
            9650320.85740911,
            3071880.313944034
        ],
        "districtid": 65
    },
    {
        "label": "Dakshinkali",
        "value": 380,
        "extent": [
            9486843.89528062,
            3194914.769087781,
            9495005.445727468,
            3205873.9633083674
        ],
        "districtid": 36
    },
    {
        "label": "Dalome",
        "value": 405,
        "extent": [
            9307966.075009327,
            3355175.5297454377,
            9378416.38883087,
            3406920.8075971724
        ],
        "districtid": 45
    },
    {
        "label": "Damak",
        "value": 14,
        "extent": [
            9755825.114167226,
            3072284.41415206,
            9764579.483574193,
            3092268.7551738843
        ],
        "districtid": 28
    },
    {
        "label": "Dangisharan",
        "value": 585,
        "extent": [
            9137910.6078613,
            3250695.2169674416,
            9156447.14242926,
            3268954.83130026
        ],
        "districtid": 15
    },
    {
        "label": "Darma",
        "value": 576,
        "extent": [
            9156519.871348914,
            3312467.092901272,
            9170717.835262787,
            3324523.5657039275
        ],
        "districtid": 63
    },
    {
        "label": "Dasharathchanda",
        "value": 767,
        "extent": [
            8943556.076473713,
            3435248.1032551797,
            8962343.173384493,
            3454818.806726077
        ],
        "districtid": 4
    },
    {
        "label": "Deumai",
        "value": 37,
        "extent": [
            9770228.071797252,
            3100613.5845518303,
            9786257.992644075,
            3129561.9607614013
        ],
        "districtid": 26
    },
    {
        "label": "Devchuli",
        "value": 773,
        "extent": [
            9367283.668175368,
            3205025.2277032784,
            9379964.968046905,
            3220893.9631238454
        ],
        "districtid": 47
    },
    {
        "label": "Devdaha",
        "value": 259,
        "extent": [
            9293899.729688324,
            3190672.624483073,
            9310069.393081535,
            3214909.1642363085
        ],
        "districtid": 62
    },
    {
        "label": "Devghat",
        "value": 335,
        "extent": [
            9383381.511729924,
            3216377.172903268,
            9403366.885861255,
            3233872.9568365277
        ],
        "districtid": 74
    },
    {
        "label": "Devtal",
        "value": 241,
        "extent": [
            9458539.519081559,
            3112518.9551424943,
            9466334.276334623,
            3121300.8719991865
        ],
        "districtid": 8
    },
    {
        "label": "Dewahhi Gonahi",
        "value": 205,
        "extent": [
            9487542.460949738,
            3107742.5174281755,
            9494428.59584452,
            3120204.89556789
        ],
        "districtid": 58
    },
    {
        "label": "Dewanganj",
        "value": 63,
        "extent": [
            9696822.456550695,
            3049122.611672753,
            9705827.330107108,
            3063461.2823146973
        ],
        "districtid": 71
    },
    {
        "label": "Dhakari",
        "value": 707,
        "extent": [
            9028220.159905756,
            3363214.639152501,
            9054457.461302705,
            3382077.6457450916
        ],
        "districtid": 1
    },
    {
        "label": "Dhanauji",
        "value": 144,
        "extent": [
            9566852.629351158,
            3079876.463040759,
            9576192.348410387,
            3085986.3791169673
        ],
        "districtid": 19
    },
    {
        "label": "Dhangadhi",
        "value": 718,
        "extent": [
            8965455.263486855,
            3320502.6346707144,
            8989759.766898101,
            3348246.8747677524
        ],
        "districtid": 31
    },
    {
        "label": "Dhangadhimai",
        "value": 272,
        "extent": [
            9611124.549378892,
            3087220.962595263,
            9628492.448982479,
            3112199.6162986313
        ],
        "districtid": 69
    },
    {
        "label": "Dhankaul",
        "value": 319,
        "extent": [
            9500243.118047439,
            3104372.879366185,
            9513381.542882517,
            3113241.718645324
        ],
        "districtid": 66
    },
    {
        "label": "Dhankuta",
        "value": 75,
        "extent": [
            9715009.918657409,
            3113133.3028594395,
            9727374.732541656,
            3129625.4133398966
        ],
        "districtid": 18
    },
    {
        "label": "Dhanpalthan",
        "value": 46,
        "extent": [
            9724338.792486593,
            3049582.299308059,
            9736703.787881717,
            3063357.200316598
        ],
        "districtid": 43
    },
    {
        "label": "Dhanusadham",
        "value": 145,
        "extent": [
            9573403.25230071,
            3098642.543843897,
            9584127.549337285,
            3118874.874862324
        ],
        "districtid": 19
    },
    {
        "label": "Dharan",
        "value": 64,
        "extent": [
            9706904.255247628,
            3087516.311032607,
            9724183.011256633,
            3108327.9757792857
        ],
        "districtid": 71
    },
    {
        "label": "Dharche",
        "value": 512,
        "extent": [
            9434176.58473339,
            3268330.5587584563,
            9476241.867793499,
            3308619.3431772483
        ],
        "districtid": 23
    },
    {
        "label": "Dharmadevi",
        "value": 87,
        "extent": [
            9711311.666356962,
            3140513.8310304945,
            9737115.497786969,
            3156831.4603524846
        ],
        "districtid": 64
    },
    {
        "label": "Dhaulagiri",
        "value": 453,
        "extent": [
            9255665.387016512,
            3303743.271518093,
            9301699.016247656,
            3349412.947601429
        ],
        "districtid": 46
    },
    {
        "label": "Dhobini",
        "value": 488,
        "extent": [
            9425394.074374134,
            3130861.139704256,
            9431175.718073444,
            3140357.221786376
        ],
        "districtid": 54
    },
    {
        "label": "Dhorchaur",
        "value": 577,
        "extent": [
            9139485.755390467,
            3301727.3374199737,
            9159114.46550908,
            3315757.552176854
        ],
        "districtid": 63
    },
    {
        "label": "Dhorpatan",
        "value": 468,
        "extent": [
            9240029.197233973,
            3286805.4401438516,
            9273341.506258149,
            3309742.679133337
        ],
        "districtid": 3
    },
    {
        "label": "Dhorpatan Hunting Reserve",
        "value": 755,
        "extent": [
            9213359.115358781,
            3327375.1598015516,
            9256487.76674088,
            3354558.625052582
        ],
        "districtid": 60
    },
    {
        "label": "Dhorpatan Hunting Reserve",
        "value": 475,
        "extent": [
            9225851.66882917,
            3307530.8179877773,
            9257486.052770969,
            3329295.6111661606
        ],
        "districtid": 3
    },
    {
        "label": "Dhorpatan Hunting Reserve",
        "value": 457,
        "extent": [
            9250630.300743293,
            3311299.5701436102,
            9264120.10752256,
            3343590.645524238
        ],
        "districtid": 46
    },
    {
        "label": "Dhulikhel",
        "value": 309,
        "extent": [
            9521237.237631604,
            3192843.378388399,
            9532022.013081532,
            3208908.3886066764
        ],
        "districtid": 30
    },
    {
        "label": "Dhunibesi",
        "value": 422,
        "extent": [
            9475160.593990713,
            3207372.1277428735,
            9492226.860358035,
            3220815.9605295984
        ],
        "districtid": 17
    },
    {
        "label": "Dhurkot",
        "value": 209,
        "extent": [
            9246873.975970877,
            3256503.320920203,
            9263047.365798155,
            3271276.4103907086
        ],
        "districtid": 24
    },
    {
        "label": "Dilasaini",
        "value": 768,
        "extent": [
            8961782.220429607,
            3453912.8266913984,
            8994158.641023383,
            3466058.657632779
        ],
        "districtid": 4
    },
    {
        "label": "Dipayal Silgadi",
        "value": 682,
        "extent": [
            8999836.935560463,
            3398750.913995157,
            9022786.138290375,
            3418386.0404005633
        ],
        "districtid": 22
    },
    {
        "label": "Diprung",
        "value": 135,
        "extent": [
            9651216.688205713,
            3128211.2807780425,
            9672540.693796685,
            3143564.723825173
        ],
        "districtid": 37
    },
    {
        "label": "Dogadakedar",
        "value": 734,
        "extent": [
            8952646.958918873,
            3444881.5531513784,
            8974297.377946671,
            3457468.1724422676
        ],
        "districtid": 4
    },
    {
        "label": "Dolpo Buddha",
        "value": 636,
        "extent": [
            9244511.830982685,
            3376249.2618589965,
            9297709.067609888,
            3448336.860429366
        ],
        "districtid": 21
    },
    {
        "label": "Doramba",
        "value": 353,
        "extent": [
            9553913.13200008,
            3183337.6319264257,
            9576254.702673746,
            3200467.5809117886
        ],
        "districtid": 56
    },
    {
        "label": "Dordi",
        "value": 295,
        "extent": [
            9394526.162596978,
            3266066.099141672,
            9428172.495204119,
            3305760.314317641
        ],
        "districtid": 39
    },
    {
        "label": "Dudhkoshi",
        "value": 98,
        "extent": [
            9640952.021171134,
            3180813.75679772,
            9661229.393871088,
            3200722.2094545215
        ],
        "districtid": 70
    },
    {
        "label": "Dudhouli",
        "value": 344,
        "extent": [
            9578651.286299583,
            3113363.942194102,
            9616056.574374637,
            3139796.281842393
        ],
        "districtid": 67
    },
    {
        "label": "Dudhpokhari",
        "value": 296,
        "extent": [
            9403819.442659346,
            3264182.0434949007,
            9424295.630779898,
            3290114.065573099
        ],
        "districtid": 39
    },
    {
        "label": "Duduwa",
        "value": 594,
        "extent": [
            9086644.92581761,
            3241623.1209597536,
            9102001.588176714,
            3265052.241173384
        ],
        "districtid": 7
    },
    {
        "label": "Duhabi",
        "value": 65,
        "extent": [
            9707552.814804511,
            3059180.139853441,
            9717706.980608689,
            3076135.0929021444
        ],
        "districtid": 71
    },
    {
        "label": "Duikholi",
        "value": 557,
        "extent": [
            9179758.579829555,
            3299957.363369651,
            9201589.376687406,
            3319556.2315474492
        ],
        "districtid": 59
    },
    {
        "label": "Dullu",
        "value": 621,
        "extent": [
            9075055.932979051,
            3345118.108212394,
            9093534.312960291,
            3363689.214674143
        ],
        "districtid": 14
    },
    {
        "label": "Dungeshwor",
        "value": 622,
        "extent": [
            9088886.216766637,
            3337237.703796065,
            9105251.077696435,
            3351462.805455929
        ],
        "districtid": 14
    },
    {
        "label": "Dunhu",
        "value": 744,
        "extent": [
            8967527.738926753,
            3483981.863006959,
            8981117.898857092,
            3495240.47857305
        ],
        "districtid": 16
    },
    {
        "label": "Dupcheshwar",
        "value": 433,
        "extent": [
            9502574.018499462,
            3233432.2788419356,
            9516420.495147372,
            3251344.942729968
        ],
        "districtid": 49
    },
    {
        "label": "Durga Bhagwati",
        "value": 206,
        "extent": [
            9494746.854790505,
            3098586.197629624,
            9501451.870859258,
            3106785.2579524275
        ],
        "districtid": 58
    },
    {
        "label": "Durgathali",
        "value": 698,
        "extent": [
            9011650.929880563,
            3436611.0671765753,
            9023043.65886453,
            3451571.1174056963
        ],
        "districtid": 5
    },
    {
        "label": "Ekdanra",
        "value": 162,
        "extent": [
            9544265.752668757,
            3080499.57881562,
            9550906.175032437,
            3087550.170674528
        ],
        "districtid": 40
    },
    {
        "label": "Fakphokthum",
        "value": 38,
        "extent": [
            9760169.306017313,
            3112276.42920082,
            9775785.759542193,
            3126134.6324682366
        ],
        "districtid": 26
    },
    {
        "label": "Falelung",
        "value": 28,
        "extent": [
            9777183.889429528,
            3135149.9440527475,
            9798257.589732332,
            3154046.877342906
        ],
        "districtid": 52
    },
    {
        "label": "Falgunanda",
        "value": 29,
        "extent": [
            9759194.974503031,
            3122502.1847117506,
            9778828.196040992,
            3136554.7396689635
        ],
        "districtid": 52
    },
    {
        "label": "Gadhawa",
        "value": 586,
        "extent": [
            9179912.460445195,
            3208236.3651406155,
            9217892.909044776,
            3229282.7618652405
        ],
        "districtid": 15
    },
    {
        "label": "Gadhi",
        "value": 66,
        "extent": [
            9701099.409819348,
            3060986.0882047242,
            9713739.915545456,
            3077415.600976063
        ],
        "districtid": 71
    },
    {
        "label": "Gadhimai",
        "value": 207,
        "extent": [
            9498915.81798126,
            3110427.4402256273,
            9506864.818916675,
            3123358.6000493295
        ],
        "districtid": 58
    },
    {
        "label": "Gaidahawa",
        "value": 260,
        "extent": [
            9262246.923993817,
            3188885.3183676167,
            9277048.543904593,
            3205177.2360417186
        ],
        "districtid": 62
    },
    {
        "label": "Gaidakot",
        "value": 774,
        "extent": [
            9378240.5091671,
            3207076.126174639,
            9398842.99516707,
            3223557.586787735
        ],
        "districtid": 47
    },
    {
        "label": "Gajuri",
        "value": 423,
        "extent": [
            9442394.679369323,
            3209117.73772462,
            9460934.528768681,
            3225925.4175371923
        ],
        "districtid": 17
    },
    {
        "label": "Galchi",
        "value": 424,
        "extent": [
            9451600.512769248,
            3211980.823094202,
            9472917.683786213,
            3230326.549185283
        ],
        "districtid": 17
    },
    {
        "label": "Galkot",
        "value": 469,
        "extent": [
            9270882.900702732,
            3269630.7595212716,
            9296701.027820528,
            3291758.8419375885
        ],
        "districtid": 3
    },
    {
        "label": "Galyang",
        "value": 389,
        "extent": [
            9304514.298534902,
            3236181.7553417943,
            9326282.85412573,
            3251271.476305602
        ],
        "districtid": 73
    },
    {
        "label": "Ganayapdhura",
        "value": 764,
        "extent": [
            8972493.807485955,
            3398105.808477205,
            8989803.398202578,
            3416284.708494266
        ],
        "districtid": 13
    },
    {
        "label": "Gandaki",
        "value": 513,
        "extent": [
            9421271.2586084,
            3223219.0834897994,
            9437919.607560046,
            3239921.266074126
        ],
        "districtid": 23
    },
    {
        "label": "Ganeshman Charnath",
        "value": 146,
        "extent": [
            9576054.708387228,
            3102148.067560533,
            9602377.04270766,
            3126136.4638232007
        ],
        "districtid": 19
    },
    {
        "label": "Gangajamuna",
        "value": 425,
        "extent": [
            9442374.16684637,
            3251100.3310176963,
            9463343.471018862,
            3269808.4582671686
        ],
        "districtid": 17
    },
    {
        "label": "Garuda",
        "value": 208,
        "extent": [
            9492920.117764425,
            3111116.7947618603,
            9503132.134600086,
            3123120.401120415
        ],
        "districtid": 58
    },
    {
        "label": "Gaumukhi",
        "value": 549,
        "extent": [
            9232658.181554819,
            3270499.7831738316,
            9250357.642270872,
            3291106.637945023
        ],
        "districtid": 55
    },
    {
        "label": "Gaumul",
        "value": 669,
        "extent": [
            9049249.114125138,
            3432339.9629074764,
            9080625.597874459,
            3464070.757014912
        ],
        "districtid": 6
    },
    {
        "label": "Gaur",
        "value": 445,
        "extent": [
            9489625.875963632,
            3092678.51751356,
            9496679.184767717,
            3098911.778990334
        ],
        "districtid": 58
    },
    {
        "label": "Gauradhaha",
        "value": 15,
        "extent": [
            9755549.498088894,
            3057305.536478127,
            9773024.946631629,
            3077128.421233698
        ],
        "districtid": 28
    },
    {
        "label": "Gauriganga",
        "value": 719,
        "extent": [
            8976350.746015524,
            3329203.2584231463,
            9005415.891611112,
            3358550.9406992933
        ],
        "districtid": 31
    },
    {
        "label": "Gauriganj",
        "value": 16,
        "extent": [
            9757926.42545588,
            3049675.8587986836,
            9777234.052585157,
            3064791.448180019
        ],
        "districtid": 28
    },
    {
        "label": "Gaurishankar",
        "value": 288,
        "extent": [
            9587147.7962256,
            3205554.5636476036,
            9635213.809330286,
            3244564.247506656
        ],
        "districtid": 20
    },
    {
        "label": "Gaushala",
        "value": 163,
        "extent": [
            9540645.520135354,
            3106938.4517464987,
            9557696.76240269,
            3125064.3993027923
        ],
        "districtid": 40
    },
    {
        "label": "Geruwa",
        "value": 605,
        "extent": [
            9033064.198034972,
            3300119.0261206343,
            9044879.448978629,
            3324056.2022507307
        ],
        "districtid": 9
    },
    {
        "label": "Ghanglekh",
        "value": 345,
        "extent": [
            9538260.80466477,
            3158336.6108938972,
            9562905.930347133,
            3175035.9245557417
        ],
        "districtid": 67
    },
    {
        "label": "Gharapjhong",
        "value": 406,
        "extent": [
            9303943.274042567,
            3333543.959027871,
            9338748.965239156,
            3358913.7304453305
        ],
        "districtid": 45
    },
    {
        "label": "Ghiring",
        "value": 336,
        "extent": [
            9343764.283813054,
            3229929.2205321365,
            9366984.517254183,
            3242519.897531034
        ],
        "districtid": 74
    },
    {
        "label": "Ghodaghodi",
        "value": 720,
        "extent": [
            8998112.856017957,
            3323228.668835808,
            9020321.580416732,
            3354710.7331807213
        ],
        "districtid": 31
    },
    {
        "label": "Ghorahi",
        "value": 587,
        "extent": [
            9165282.06340603,
            3235951.704849024,
            9197444.44220017,
            3268403.556866383
        ],
        "districtid": 15
    },
    {
        "label": "Godaita",
        "value": 320,
        "extent": [
            9506219.524033347,
            3096747.6625943966,
            9516042.893610423,
            3111766.69382168
        ],
        "districtid": 66
    },
    {
        "label": "Godawari",
        "value": 721,
        "extent": [
            8957665.766292626,
            3340843.142007345,
            8980783.09244978,
            3375546.828610001
        ],
        "districtid": 31
    },
    {
        "label": "Godawari",
        "value": 329,
        "extent": [
            9489994.244479882,
            3189621.891028236,
            9508184.783376535,
            3202918.8168470487
        ],
        "districtid": 38
    },
    {
        "label": "Gokarneshwor",
        "value": 381,
        "extent": [
            9502712.619052226,
            3212545.229033907,
            9514634.391755437,
            3225993.810238493
        ],
        "districtid": 36
    },
    {
        "label": "Gokulganga",
        "value": 354,
        "extent": [
            9587115.321359957,
            3179739.4338801694,
            9620265.358979555,
            3213587.682112886
        ],
        "districtid": 56
    },
    {
        "label": "Golanjor",
        "value": 346,
        "extent": [
            9568396.471343106,
            3146603.7492297958,
            9596264.301144307,
            3165786.74274727
        ],
        "districtid": 67
    },
    {
        "label": "Golbazar",
        "value": 273,
        "extent": [
            9603660.504516738,
            3087809.276368972,
            9618786.39085394,
            3109983.776797877
        ],
        "districtid": 69
    },
    {
        "label": "Gorkha",
        "value": 514,
        "extent": [
            9403496.66524076,
            3236980.0164105026,
            9429111.493788412,
            3255281.9902026453
        ],
        "districtid": 23
    },
    {
        "label": "Gosaikunda",
        "value": 413,
        "extent": [
            9487526.218771838,
            3253615.4478989993,
            9551223.958663145,
            3297753.782072745
        ],
        "districtid": 57
    },
    {
        "label": "Gramthan",
        "value": 47,
        "extent": [
            9717875.844508652,
            3061351.3388214805,
            9730011.119161982,
            3074697.2477791193
        ],
        "districtid": 43
    },
    {
        "label": "Gujara",
        "value": 446,
        "extent": [
            9485103.836473437,
            3123026.4780725553,
            9498413.33836749,
            3152593.452883
        ],
        "districtid": 58
    },
    {
        "label": "Gulariya",
        "value": 606,
        "extent": [
            9048092.659484958,
            3265820.779439084,
            9062907.681280885,
            3285180.8770555826
        ],
        "districtid": 9
    },
    {
        "label": "Gulmidarbar",
        "value": 210,
        "extent": [
            9268734.3551465,
            3244445.4994552545,
            9280345.92551903,
            3263584.4535385543
        ],
        "districtid": 24
    },
    {
        "label": "Gurans",
        "value": 623,
        "extent": [
            9077702.105169578,
            3329058.02209094,
            9107550.384066967,
            3348485.905478025
        ],
        "districtid": 14
    },
    {
        "label": "Gurbhakot",
        "value": 613,
        "extent": [
            9106915.730852779,
            3291557.4606138836,
            9127055.903078107,
            3316848.103381084
        ],
        "districtid": 72
    },
    {
        "label": "Guthichaur",
        "value": 644,
        "extent": [
            9149127.207872592,
            3387807.1198218986,
            9192997.354448408,
            3413755.7336812485
        ],
        "districtid": 29
    },
    {
        "label": "Haldibari",
        "value": 17,
        "extent": [
            9789009.295007125,
            3054783.5631159255,
            9802826.70932741,
            3071551.4043381764
        ],
        "districtid": 28
    },
    {
        "label": "Halesi Tuwachung",
        "value": 136,
        "extent": [
            9620915.276480956,
            3134506.971377866,
            9657082.887920633,
            3154307.1949763414
        ],
        "districtid": 37
    },
    {
        "label": "Hansapur",
        "value": 147,
        "extent": [
            9571299.990982529,
            3088382.360079632,
            9581287.905609557,
            3099480.878599242
        ],
        "districtid": 19
    },
    {
        "label": "Hanumannagar Kankalini",
        "value": 186,
        "extent": [
            9660312.578380963,
            3053556.6151781096,
            9681778.613274561,
            3071689.5883988617
        ],
        "districtid": 65
    },
    {
        "label": "Hariharpurgadhi",
        "value": 347,
        "extent": [
            9508693.289812816,
            3140598.354706264,
            9534547.211059583,
            3170577.018904678
        ],
        "districtid": 67
    },
    {
        "label": "Harinagar",
        "value": 67,
        "extent": [
            9693668.802367622,
            3053322.8167371065,
            9701964.491185566,
            3067157.6754806894
        ],
        "districtid": 71
    },
    {
        "label": "Harinas",
        "value": 390,
        "extent": [
            9339368.586072482,
            3236268.577013796,
            9354380.859706834,
            3255771.4008315243
        ],
        "districtid": 73
    },
    {
        "label": "Haripur",
        "value": 321,
        "extent": [
            9516681.563374761,
            3118931.67780049,
            9528921.700031815,
            3131570.9649393596
        ],
        "districtid": 66
    },
    {
        "label": "Haripurwa",
        "value": 322,
        "extent": [
            9534987.210382074,
            3107356.5590501847,
            9542706.094185498,
            3117905.289978012
        ],
        "districtid": 66
    },
    {
        "label": "Hariwan",
        "value": 323,
        "extent": [
            9519443.872292401,
            3128100.240928379,
            9534148.985700374,
            3142072.5968140755
        ],
        "districtid": 66
    },
    {
        "label": "Hatuwagadhi",
        "value": 91,
        "extent": [
            9691263.572320392,
            3112928.5067090564,
            9706876.921871856,
            3132830.31417051
        ],
        "districtid": 11
    },
    {
        "label": "Helambu",
        "value": 366,
        "extent": [
            9511318.328036148,
            3230749.937622805,
            9530644.59951315,
            3268824.3491181103
        ],
        "districtid": 68
    },
    {
        "label": "Hetauda",
        "value": 116,
        "extent": [
            9449747.810065879,
            3163061.570704102,
            9483039.537145857,
            3189365.918253816
        ],
        "districtid": 41
    },
    {
        "label": "Hilihang",
        "value": 30,
        "extent": [
            9760463.556112498,
            3142272.223878096,
            9778511.354463428,
            3159916.1638529473
        ],
        "districtid": 52
    },
    {
        "label": "Hima",
        "value": 645,
        "extent": [
            9111074.112384873,
            3401295.0089188837,
            9132590.749005988,
            3419087.989241551
        ],
        "districtid": 29
    },
    {
        "label": "Himali",
        "value": 670,
        "extent": [
            9073148.782638468,
            3436136.4888106044,
            9105868.991640331,
            3497022.0924703246
        ],
        "districtid": 6
    },
    {
        "label": "Hupsekot",
        "value": 775,
        "extent": [
            9342393.157427123,
            3201386.4813266653,
            9368471.060252737,
            3221344.563145444
        ],
        "districtid": 47
    },
    {
        "label": "Ichchhyakamana",
        "value": 501,
        "extent": [
            9405848.302684741,
            3214666.1091121337,
            9426687.110032823,
            3233911.803976219
        ],
        "districtid": 12
    },
    {
        "label": "Illam",
        "value": 39,
        "extent": [
            9778426.261050148,
            3100545.1551209497,
            9797361.96328489,
            3131325.3742441186
        ],
        "districtid": 26
    },
    {
        "label": "Inaruwa",
        "value": 68,
        "extent": [
            9696922.383616347,
            3065865.283231771,
            9710952.371626897,
            3081290.1651988286
        ],
        "districtid": 71
    },
    {
        "label": "Indrasarowar",
        "value": 117,
        "extent": [
            9476705.226246562,
            3190737.408824892,
            9491427.542043768,
            3206963.2967102947
        ],
        "districtid": 41
    },
    {
        "label": "Indrawati",
        "value": 367,
        "extent": [
            9526002.731726937,
            3211873.8647328173,
            9539066.220165988,
            3232252.362785319
        ],
        "districtid": 68
    },
    {
        "label": "Ishanath",
        "value": 447,
        "extent": [
            9481820.575987648,
            3093064.2160783373,
            9490900.73441073,
            3103674.382410484
        ],
        "districtid": 58
    },
    {
        "label": "Ishworpur",
        "value": 324,
        "extent": [
            9527421.528674014,
            3113374.360031738,
            9552965.069589503,
            3143730.1720231534
        ],
        "districtid": 66
    },
    {
        "label": "Isma",
        "value": 211,
        "extent": [
            9255805.968710024,
            3260979.109938775,
            9268497.429908127,
            3278464.765455819
        ],
        "districtid": 24
    },
    {
        "label": "Itahari",
        "value": 69,
        "extent": [
            9707317.615004653,
            3074840.195134338,
            9721329.978277108,
            3090708.709013104
        ],
        "districtid": 71
    },
    {
        "label": "Jagadulla",
        "value": 637,
        "extent": [
            9176398.105201658,
            3382348.6516854158,
            9216850.526291866,
            3430310.065868141
        ],
        "districtid": 21
    },
    {
        "label": "Jagarnathpur",
        "value": 489,
        "extent": [
            9425995.560504707,
            3135325.280784072,
            9437683.53996531,
            3147531.6990506984
        ],
        "districtid": 54
    },
    {
        "label": "Jahada",
        "value": 48,
        "extent": [
            9717026.737861348,
            3042216.9039533422,
            9725851.830683805,
            3057567.8220625026
        ],
        "districtid": 43
    },
    {
        "label": "Jaimuni",
        "value": 470,
        "extent": [
            9296147.963101104,
            3258733.620948019,
            9311582.530758772,
            3276866.4134993036
        ],
        "districtid": 3
    },
    {
        "label": "Jaleswor",
        "value": 189,
        "extent": [
            9545521.935107421,
            3073782.943651742,
            9555889.571796205,
            3083923.9476457876
        ],
        "districtid": 40
    },
    {
        "label": "Jaljala",
        "value": 459,
        "extent": [
            9302444.046920389,
            3282656.700081132,
            9313323.501893824,
            3298453.2653903435
        ],
        "districtid": 53
    },
    {
        "label": "Janaki",
        "value": 722,
        "extent": [
            9021362.629578901,
            3314908.8971079406,
            9045874.26203216,
            3326681.9625883983
        ],
        "districtid": 31
    },
    {
        "label": "Janaknandani",
        "value": 148,
        "extent": [
            9583222.307386689,
            3074210.2566451146,
            9593897.50896651,
            3082055.251176453
        ],
        "districtid": 19
    },
    {
        "label": "Janakpur",
        "value": 149,
        "extent": [
            9560034.655705428,
            3082372.1180851115,
            9572808.368660977,
            3096609.8171697473
        ],
        "districtid": 19
    },
    {
        "label": "Janki",
        "value": 595,
        "extent": [
            9076729.289814083,
            3252073.2438237597,
            9091719.198660862,
            3267622.4736967864
        ],
        "districtid": 7
    },
    {
        "label": "Jantedhunga",
        "value": 137,
        "extent": [
            9666667.432994075,
            3110612.8331330856,
            9681776.874873519,
            3128935.5162440757
        ],
        "districtid": 37
    },
    {
        "label": "JayaPrithivi",
        "value": 699,
        "extent": [
            9029433.320617368,
            3435327.1421021638,
            9051516.140645795,
            3456712.4235949013
        ],
        "districtid": 5
    },
    {
        "label": "Jhapa",
        "value": 18,
        "extent": [
            9775113.5482959,
            3053244.369573714,
            9786681.154768303,
            3072368.9581526946
        ],
        "districtid": 28
    },
    {
        "label": "Jhimruk",
        "value": 550,
        "extent": [
            9229091.580513489,
            3261468.7748209843,
            9246086.33459226,
            3273931.2726664403
        ],
        "districtid": 55
    },
    {
        "label": "Jirabhawani",
        "value": 490,
        "extent": [
            9426436.613853471,
            3142721.945889387,
            9437391.604130823,
            3154578.1014542845
        ],
        "districtid": 54
    },
    {
        "label": "Jiri",
        "value": 289,
        "extent": [
            9590308.141281674,
            3193876.8892211057,
            9621059.946774675,
            3220449.9561308203
        ],
        "districtid": 20
    },
    {
        "label": "Jitpur Simara",
        "value": 242,
        "extent": [
            9453708.175719671,
            3131360.080973584,
            9472654.074255124,
            3169231.7611445333
        ],
        "districtid": 8
    },
    {
        "label": "Jorayal",
        "value": 683,
        "extent": [
            8964128.15260059,
            3376555.171970963,
            9002369.070603998,
            3400469.476351318
        ],
        "districtid": 22
    },
    {
        "label": "Joshipur",
        "value": 723,
        "extent": [
            9015093.079245958,
            3313928.0993119655,
            9024281.40724799,
            3327884.090858527
        ],
        "districtid": 31
    },
    {
        "label": "Jugal",
        "value": 368,
        "extent": [
            9538074.016847206,
            3224208.126064678,
            9562699.818271274,
            3274640.3534519337
        ],
        "districtid": 68
    },
    {
        "label": "Junichande",
        "value": 631,
        "extent": [
            9114645.757319476,
            3346920.780695869,
            9137554.515314775,
            3379543.5144819473
        ],
        "districtid": 27
    },
    {
        "label": "Jwalamukhi",
        "value": 426,
        "extent": [
            9432311.16744055,
            3230987.6078233933,
            9445910.326449415,
            3246627.25788155
        ],
        "districtid": 17
    },
    {
        "label": "Kabilasi",
        "value": 325,
        "extent": [
            9517695.796110012,
            3109766.6654438833,
            9526565.106343811,
            3122225.3787547518
        ],
        "districtid": 66
    },
    {
        "label": "Kachankawal",
        "value": 19,
        "extent": [
            9784824.322206873,
            3043874.714928842,
            9805961.869354159,
            3057343.3014072133
        ],
        "districtid": 28
    },
    {
        "label": "Kageshwori Manahora",
        "value": 382,
        "extent": [
            9502729.777387628,
            3209834.7517514327,
            9514415.8859025,
            3220761.9440917643
        ],
        "districtid": 36
    },
    {
        "label": "Kaike",
        "value": 638,
        "extent": [
            9232274.012508016,
            3342994.643005738,
            9258327.808712272,
            3388446.679350814
        ],
        "districtid": 21
    },
    {
        "label": "Kailari",
        "value": 724,
        "extent": [
            8985223.937294504,
            3310835.8595990078,
            9007057.818262164,
            3338436.5336283767
        ],
        "districtid": 31
    },
    {
        "label": "Kailash",
        "value": 118,
        "extent": [
            9448317.009071251,
            3188499.0027155466,
            9466046.271558885,
            3211023.7518999814
        ],
        "districtid": 41
    },
    {
        "label": "Kakani",
        "value": 434,
        "extent": [
            9480392.906888613,
            3219531.7801605593,
            9494424.605133682,
            3233617.051070112
        ],
        "districtid": 49
    },
    {
        "label": "Kalaiya",
        "value": 243,
        "extent": [
            9455854.278464299,
            3115602.5682037207,
            9470304.46700464,
            3137895.221657512
        ],
        "districtid": 8
    },
    {
        "label": "Kaligandagi",
        "value": 391,
        "extent": [
            9288471.92509538,
            3239226.3752692887,
            9308541.838555474,
            3246706.6869295323
        ],
        "districtid": 73
    },
    {
        "label": "Kaligandaki",
        "value": 212,
        "extent": [
            9292704.284389375,
            3245650.3420845885,
            9306883.274424613,
            3264987.7968232753
        ],
        "districtid": 24
    },
    {
        "label": "Kalika",
        "value": 651,
        "extent": [
            9079406.607098315,
            3379901.327277344,
            9094317.207245892,
            3391797.3821696085
        ],
        "districtid": 32
    },
    {
        "label": "Kalika",
        "value": 414,
        "extent": [
            9483622.875876386,
            3245539.183450266,
            9490460.197497264,
            3259804.170048599
        ],
        "districtid": 57
    },
    {
        "label": "Kalika",
        "value": 502,
        "extent": [
            9403755.419682154,
            3205596.290618719,
            9428010.594967391,
            3220481.889913662
        ],
        "districtid": 12
    },
    {
        "label": "Kalikamai",
        "value": 491,
        "extent": [
            9428257.521161342,
            3127782.5487349355,
            9434967.023391053,
            3138083.9311315482
        ],
        "districtid": 54
    },
    {
        "label": "Kalimati",
        "value": 578,
        "extent": [
            9099623.844509836,
            3274337.963485519,
            9145000.108611498,
            3298518.8342139143
        ],
        "districtid": 63
    },
    {
        "label": "Kalinchok",
        "value": 290,
        "extent": [
            9575666.141339082,
            3208599.997561116,
            9591859.735458734,
            3226140.0613036086
        ],
        "districtid": 20
    },
    {
        "label": "Kalyanpur",
        "value": 274,
        "extent": [
            9589551.36955713,
            3085465.640825598,
            9602434.67730216,
            3100251.4304043
        ],
        "districtid": 69
    },
    {
        "label": "Kamal",
        "value": 20,
        "extent": [
            9755921.074230568,
            3063456.78470504,
            9773032.647232438,
            3085692.9245285653
        ],
        "districtid": 28
    },
    {
        "label": "Kamala",
        "value": 150,
        "extent": [
            9584345.918914758,
            3080535.2825217457,
            9595746.952844653,
            3093916.0746218343
        ],
        "districtid": 19
    },
    {
        "label": "Kamalamai",
        "value": 348,
        "extent": [
            9550182.522552747,
            3125797.676722906,
            9582154.060421707,
            3164559.5992585914
        ],
        "districtid": 67
    },
    {
        "label": "Kamalbazar",
        "value": 708,
        "extent": [
            9044620.974301828,
            3376405.283905424,
            9064459.864367131,
            3391515.6479765694
        ],
        "districtid": 1
    },
    {
        "label": "Kanakasundari",
        "value": 646,
        "extent": [
            9120106.590050723,
            3419125.766038529,
            9148159.96760897,
            3437403.591963742
        ],
        "districtid": 29
    },
    {
        "label": "Kanchan",
        "value": 261,
        "extent": [
            9264066.504125,
            3196090.978205418,
            9274412.755522326,
            3210908.7577305916
        ],
        "districtid": 62
    },
    {
        "label": "Kanchanrup",
        "value": 187,
        "extent": [
            9665143.174471445,
            3067188.0604689075,
            9683462.384588199,
            3087616.2895868546
        ],
        "districtid": 65
    },
    {
        "label": "Kanda",
        "value": 700,
        "extent": [
            9016934.007517189,
            3459758.3101835228,
            9079762.651013311,
            3510523.5091814394
        ],
        "districtid": 5
    },
    {
        "label": "Kanepokhari",
        "value": 49,
        "extent": [
            9734929.714706704,
            3064488.189615348,
            9744915.191699626,
            3082972.4602650395
        ],
        "districtid": 43
    },
    {
        "label": "Kankai",
        "value": 21,
        "extent": [
            9780007.503555486,
            3070712.7760404823,
            9791206.275219824,
            3085724.483963735
        ],
        "districtid": 28
    },
    {
        "label": "Kanthekhola",
        "value": 471,
        "extent": [
            9291259.062544871,
            3274514.9510239647,
            9302271.032362835,
            3289925.768508924
        ],
        "districtid": 3
    },
    {
        "label": "Kapilbastu",
        "value": 535,
        "extent": [
            9237763.334586821,
            3184110.6069246684,
            9255202.476347428,
            3204863.577913969
        ],
        "districtid": 34
    },
    {
        "label": "Kapurkot",
        "value": 579,
        "extent": [
            9159811.029644916,
            3270278.0930796834,
            9176868.078704417,
            3290650.4201910538
        ],
        "districtid": 63
    },
    {
        "label": "Karaiyamai",
        "value": 244,
        "extent": [
            9467599.266515817,
            3119350.553596687,
            9477164.056724235,
            3133620.379207902
        ],
        "districtid": 8
    },
    {
        "label": "Karjanha",
        "value": 275,
        "extent": [
            9588049.8077683,
            3099986.4411654104,
            9600963.761163212,
            3115388.890585114
        ],
        "districtid": 69
    },
    {
        "label": "Katahari",
        "value": 50,
        "extent": [
            9716928.271186216,
            3053476.9762523244,
            9730561.927591981,
            3065897.557390921
        ],
        "districtid": 43
    },
    {
        "label": "Katahariya",
        "value": 448,
        "extent": [
            9486405.550562514,
            3116871.9831751506,
            9494315.369165532,
            3130002.8747156477
        ],
        "districtid": 58
    },
    {
        "label": "Katari",
        "value": 103,
        "extent": [
            9590820.652485033,
            3106462.1362227825,
            9628251.679437889,
            3145961.452206304
        ],
        "districtid": 77
    },
    {
        "label": "Kathmandu",
        "value": 383,
        "extent": [
            9493008.472570335,
            3207167.8718617554,
            9503617.36816679,
            3217490.929398297
        ],
        "districtid": 36
    },
    {
        "label": "Kaudena",
        "value": 326,
        "extent": [
            9514832.81903861,
            3100184.2877089796,
            9522467.542127486,
            3109402.6128029837
        ],
        "districtid": 66
    },
    {
        "label": "Kawasoti",
        "value": 776,
        "extent": [
            9357680.274856888,
            3192973.646531939,
            9372030.420981126,
            3217276.7964625726
        ],
        "districtid": 47
    },
    {
        "label": "Kedarseu",
        "value": 701,
        "extent": [
            9001146.530074919,
            3432385.2639741646,
            9018376.141684314,
            3449447.3688253723
        ],
        "districtid": 5
    },
    {
        "label": "Kepilasagadhi",
        "value": 138,
        "extent": [
            9658594.08425693,
            3156682.320239202,
            9683150.43023038,
            3177981.6323295296
        ],
        "districtid": 37
    },
    {
        "label": "Kerabari",
        "value": 51,
        "extent": [
            9720768.983053911,
            3083314.4946303503,
            9741674.66253716,
            3107671.5142734875
        ],
        "districtid": 43
    },
    {
        "label": "Khadadevi",
        "value": 355,
        "extent": [
            9552202.411875699,
            3167447.550912262,
            9576805.355597787,
            3186315.0982100246
        ],
        "districtid": 56
    },
    {
        "label": "Khadak",
        "value": 188,
        "extent": [
            9633837.045551406,
            3068966.789694862,
            9646578.731335428,
            3086021.130226621
        ],
        "districtid": 65
    },
    {
        "label": "Khairahani",
        "value": 503,
        "extent": [
            9407992.51126025,
            3192047.0836495683,
            9422429.466790728,
            3209307.3966331477
        ],
        "districtid": 12
    },
    {
        "label": "Khajura",
        "value": 596,
        "extent": [
            9072375.41298529,
            3255726.1072501484,
            9088329.004526462,
            3272993.395706318
        ],
        "districtid": 7
    },
    {
        "label": "Khandachakra",
        "value": 652,
        "extent": [
            9081345.310061265,
            3388781.8041359033,
            9102279.997056918,
            3402654.1561289704
        ],
        "districtid": 32
    },
    {
        "label": "Khandbari",
        "value": 88,
        "extent": [
            9698575.160351662,
            3157338.164318756,
            9713451.735828439,
            3181361.605304412
        ],
        "districtid": 64
    },
    {
        "label": "Khanikhola",
        "value": 310,
        "extent": [
            9507719.039759053,
            3169589.0477071316,
            9526231.503515495,
            3184590.460405372
        ],
        "districtid": 30
    },
    {
        "label": "Khaniyabash",
        "value": 427,
        "extent": [
            9458302.779806029,
            3252116.4126940677,
            9476249.511684267,
            3266697.182675701
        ],
        "districtid": 17
    },
    {
        "label": "Khaptadchhanna",
        "value": 702,
        "extent": [
            9026632.843696788,
            3428004.668162511,
            9051123.694119863,
            3440159.778989489
        ],
        "districtid": 5
    },
    {
        "label": "Khaptad National Park",
        "value": 678,
        "extent": [
            9031885.269469805,
            3413195.2916505043,
            9041952.189810831,
            3424943.2143606404
        ],
        "districtid": 1
    },
    {
        "label": "Khaptad National Park",
        "value": 714,
        "extent": [
            9019453.793333018,
            3414843.8164002458,
            9037679.79903598,
            3428132.244258801
        ],
        "districtid": 22
    },
    {
        "label": "Khaptad National Park",
        "value": 704,
        "extent": [
            9019620.096649649,
            3425488.6329771196,
            9042147.375909792,
            3435077.821594986
        ],
        "districtid": 5
    },
    {
        "label": "Khaptad National Park",
        "value": 694,
        "extent": [
            9035790.530053582,
            3423038.095477255,
            9042146.890285704,
            3428149.5849505467
        ],
        "districtid": 6
    },
    {
        "label": "Kharpunath",
        "value": 660,
        "extent": [
            9103691.601924945,
            3479198.78445045,
            9154664.332023462,
            3548567.5085403128
        ],
        "districtid": 25
    },
    {
        "label": "Khatyad",
        "value": 692,
        "extent": [
            9101745.80314505,
            3431422.8581622425,
            9133145.921901347,
            3455117.965747228
        ],
        "districtid": 44
    },
    {
        "label": "Khijidemba",
        "value": 167,
        "extent": [
            9602019.123250898,
            3169699.148508483,
            9624059.712172601,
            3189367.9919289635
        ],
        "districtid": 50
    },
    {
        "label": "Khotehang",
        "value": 139,
        "extent": [
            9654362.480862936,
            3120264.925480767,
            9680846.325968925,
            3137833.0573566025
        ],
        "districtid": 37
    },
    {
        "label": "Khumbupasanglahmu",
        "value": 99,
        "extent": [
            9630477.18034801,
            3195133.3607858173,
            9682922.359741786,
            3263226.295071459
        ],
        "districtid": 70
    },
    {
        "label": "Kirtipur",
        "value": 384,
        "extent": [
            9489815.670197934,
            3204194.6606245493,
            9495471.743885621,
            3210158.4204088775
        ],
        "districtid": 36
    },
    {
        "label": "K I Singh",
        "value": 684,
        "extent": [
            9003392.165497141,
            3390516.0243098075,
            9022928.9567976,
            3406314.013058467
        ],
        "districtid": 22
    },
    {
        "label": "Kispang",
        "value": 435,
        "extent": [
            9468654.019670315,
            3246222.490108548,
            9483008.287548264,
            3260474.146429654
        ],
        "districtid": 49
    },
    {
        "label": "Kohalpur",
        "value": 597,
        "extent": [
            9086291.958990423,
            3264150.893974656,
            9109144.067989092,
            3288756.167393252
        ],
        "districtid": 7
    },
    {
        "label": "Kolhabi",
        "value": 245,
        "extent": [
            9470135.601979505,
            3123842.23777055,
            9485103.836473437,
            3146001.2583304793
        ],
        "districtid": 8
    },
    {
        "label": "Konjyosom",
        "value": 330,
        "extent": [
            9496159.56138849,
            3183164.4783593747,
            9507077.292230478,
            3194070.9066466554
        ],
        "districtid": 38
    },
    {
        "label": "Koshi",
        "value": 70,
        "extent": [
            9674099.267527148,
            3059682.9059673636,
            9693436.645784404,
            3078135.6661142358
        ],
        "districtid": 71
    },
    {
        "label": "Koshi Tappu Wildlife Reserve",
        "value": 266,
        "extent": [
            9675736.5365628,
            3069700.229568208,
            9686407.319637716,
            3087387.6838244745
        ],
        "districtid": 65
    },
    {
        "label": "Koshi Tappu Wildlife Reserve",
        "value": 72,
        "extent": [
            9682427.205391917,
            3069550.542794534,
            9693188.218232816,
            3088787.5814735712
        ],
        "districtid": 71
    },
    {
        "label": "Koshi Tappu Wildlife Reserve",
        "value": 178,
        "extent": [
            9682963.460857956,
            3085809.8986847466,
            9686358.70439814,
            3089664.8631030945
        ],
        "districtid": 77
    },
    {
        "label": "Kotahimai",
        "value": 262,
        "extent": [
            9272215.438317295,
            3173904.7475110847,
            9284326.865345184,
            3184777.148348645
        ],
        "districtid": 62
    },
    {
        "label": "Krishnanagar",
        "value": 536,
        "extent": [
            9210010.028790338,
            3185641.9790213523,
            9228127.352610722,
            3195184.631498754
        ],
        "districtid": 34
    },
    {
        "label": "Krishnapur",
        "value": 732,
        "extent": [
            8948984.32408829,
            3338965.4351985017,
            8967833.011890806,
            3380414.0681613046
        ],
        "districtid": 33
    },
    {
        "label": "Kumakhmalika",
        "value": 580,
        "extent": [
            9139886.394579796,
            3309749.2367977626,
            9159476.155344445,
            3328195.270036331
        ],
        "districtid": 63
    },
    {
        "label": "Kummayak",
        "value": 31,
        "extent": [
            9744319.63946488,
            3124117.3645428573,
            9762096.844869705,
            3141485.8284494383
        ],
        "districtid": 52
    },
    {
        "label": "Kuse",
        "value": 632,
        "extent": [
            9134323.83770587,
            3345859.4473601882,
            9154306.889566138,
            3375073.68451714
        ],
        "districtid": 27
    },
    {
        "label": "Kushma",
        "value": 460,
        "extent": [
            9307301.959201656,
            3271874.103937528,
            9329595.898609413,
            3285107.6694071335
        ],
        "districtid": 53
    },
    {
        "label": "Kwholasothar",
        "value": 297,
        "extent": [
            9371619.392937839,
            3274524.7443124875,
            9388206.927510576,
            3301933.3704138873
        ],
        "districtid": 39
    },
    {
        "label": "Lahan",
        "value": 276,
        "extent": [
            9620045.130900184,
            3080348.348865632,
            9635204.762051761,
            3105997.702643277
        ],
        "districtid": 69
    },
    {
        "label": "Lakshminiya",
        "value": 151,
        "extent": [
            9563161.44384698,
            3093718.6707233638,
            9570503.671363646,
            3102856.155926381
        ],
        "districtid": 19
    },
    {
        "label": "Lalbandi",
        "value": 327,
        "extent": [
            9524883.157981537,
            3123790.4558980744,
            9552557.208674615,
            3147876.516189331
        ],
        "districtid": 66
    },
    {
        "label": "Laligurans",
        "value": 82,
        "extent": [
            9728423.784876034,
            3132992.053236249,
            9742010.244473381,
            3146465.131355885
        ],
        "districtid": 76
    },
    {
        "label": "Lalitpur",
        "value": 332,
        "extent": [
            9493575.682267904,
            3199429.083085259,
            9501450.973307965,
            3210379.6534835217
        ],
        "districtid": 38
    },
    {
        "label": "Laljhadi",
        "value": 733,
        "extent": [
            8943222.836381573,
            3333215.8695784486,
            8962563.59201582,
            3356238.2220086446
        ],
        "districtid": 33
    },
    {
        "label": "Lamahi",
        "value": 588,
        "extent": [
            9148886.018321732,
            3227941.7169572604,
            9198307.655563071,
            3252571.520228466
        ],
        "districtid": 15
    },
    {
        "label": "Lamkichuha",
        "value": 725,
        "extent": [
            9022822.514602814,
            3322836.738752137,
            9048897.107775157,
            3341431.9946425217
        ],
        "districtid": 31
    },
    {
        "label": "Langtang National Park",
        "value": 444,
        "extent": [
            9503245.02211574,
            3244430.2534670616,
            9517484.028953718,
            3259383.0447659194
        ],
        "districtid": 49
    },
    {
        "label": "Laxmipur Patari",
        "value": 277,
        "extent": [
            9614814.225569576,
            3076360.5144151407,
            9624312.187123183,
            3088092.7066474576
        ],
        "districtid": 69
    },
    {
        "label": "Lekam",
        "value": 745,
        "extent": [
            8948226.115831424,
            3452868.493574322,
            8964334.067383025,
            3466272.1311815805
        ],
        "districtid": 16
    },
    {
        "label": "Lekbeshi",
        "value": 614,
        "extent": [
            9091146.688473491,
            3305925.4661528743,
            9111369.180485396,
            3327462.250809379
        ],
        "districtid": 72
    },
    {
        "label": "Letang",
        "value": 52,
        "extent": [
            9733850.959625406,
            3081883.4247818524,
            9753140.781421477,
            3106407.4915538393
        ],
        "districtid": 43
    },
    {
        "label": "Likhu",
        "value": 436,
        "extent": [
            9480907.851310266,
            3228849.6851298516,
            9493941.767646594,
            3240679.5907909777
        ],
        "districtid": 49
    },
    {
        "label": "Likhu",
        "value": 168,
        "extent": [
            9597470.510916432,
            3161370.557402435,
            9611700.512954433,
            3178932.3021504097
        ],
        "districtid": 50
    },
    {
        "label": "Likhupike",
        "value": 100,
        "extent": [
            9613048.719964357,
            3184150.4658593745,
            9630330.6936024,
            3200792.872553037
        ],
        "districtid": 70
    },
    {
        "label": "Likhu Tamakoshi",
        "value": 356,
        "extent": [
            9583112.104019925,
            3171412.0532488916,
            9602734.018417854,
            3188027.1883007
        ],
        "districtid": 56
    },
    {
        "label": "Lisangkhu Pakhar",
        "value": 369,
        "extent": [
            9552600.7792473,
            3199944.76238571,
            9566710.186218467,
            3216718.9818528323
        ],
        "districtid": 68
    },
    {
        "label": "Loharpatti",
        "value": 190,
        "extent": [
            9554418.37821998,
            3087063.516360883,
            9563529.23441874,
            3100811.3374766777
        ],
        "districtid": 40
    },
    {
        "label": "Lomanthang",
        "value": 407,
        "extent": [
            9322667.238168878,
            3384856.2709004846,
            9373415.83992726,
            3417878.7854334195
        ],
        "districtid": 45
    },
    {
        "label": "Lumbini Sanskritik",
        "value": 263,
        "extent": [
            9263647.80922928,
            3172766.6581262476,
            9276243.661450183,
            3191629.148623082
        ],
        "districtid": 62
    },
    {
        "label": "Lumbini Sanskritik Development Area",
        "value": 531,
        "extent": [
            9269295.646588365,
            3181350.643306303,
            9271206.68609734,
            3186838.057468596
        ],
        "districtid": 62
    },
    {
        "label": "Lungri",
        "value": 558,
        "extent": [
            9209681.69638182,
            3272489.1777045163,
            9228831.127618521,
            3292960.711112142
        ],
        "districtid": 59
    },
    {
        "label": "Machhapuchchhre",
        "value": 396,
        "extent": [
            9331658.944048414,
            3285027.3615925815,
            9360324.77341386,
            3325496.143381869
        ],
        "districtid": 35
    },
    {
        "label": "Madane",
        "value": 213,
        "extent": [
            9241942.409091769,
            3262431.4003135366,
            9253397.681807252,
            3279721.4953691834
        ],
        "districtid": 24
    },
    {
        "label": "Madhav Narayan",
        "value": 449,
        "extent": [
            9492253.713220842,
            3105284.1580508207,
            9506173.251289358,
            3114018.3823681665
        ],
        "districtid": 58
    },
    {
        "label": "Madhuwan",
        "value": 607,
        "extent": [
            9038374.434078896,
            3278605.926535604,
            9051580.354452323,
            3304356.005664131
        ],
        "districtid": 9
    },
    {
        "label": "Madhyabindu",
        "value": 777,
        "extent": [
            9339215.620053878,
            3191183.755357814,
            9359633.404003661,
            3214919.078315214
        ],
        "districtid": 47
    },
    {
        "label": "MadhyaNepal",
        "value": 298,
        "extent": [
            9372048.797327807,
            3258894.9774583583,
            9387089.488422567,
            3276253.640682204
        ],
        "districtid": 39
    },
    {
        "label": "Madhyapur Thimi",
        "value": 411,
        "extent": [
            9501331.883367391,
            3207150.104753483,
            9507345.583110321,
            3211578.509043012
        ],
        "districtid": 10
    },
    {
        "label": "Madi",
        "value": 397,
        "extent": [
            9352905.266203998,
            3272836.2899276395,
            9381849.174058545,
            3317149.7341346485
        ],
        "districtid": 35
    },
    {
        "label": "Madi",
        "value": 504,
        "extent": [
            9379093.608266408,
            3167890.4880709075,
            9410909.390810993,
            3187810.0435220283
        ],
        "districtid": 12
    },
    {
        "label": "Madi",
        "value": 559,
        "extent": [
            9174512.93873985,
            3291631.5558439945,
            9193593.325932775,
            3307889.799589314
        ],
        "districtid": 59
    },
    {
        "label": "Madi",
        "value": 126,
        "extent": [
            9721078.959380755,
            3148678.094915087,
            9739791.75885884,
            3161246.1120562167
        ],
        "districtid": 64
    },
    {
        "label": "Mahabharat",
        "value": 311,
        "extent": [
            9518158.111232838,
            3165199.1745701884,
            9541826.3388618,
            3181333.880254057
        ],
        "districtid": 30
    },
    {
        "label": "Mahabu",
        "value": 624,
        "extent": [
            9089120.89858947,
            3356932.6186451414,
            9099770.342803888,
            3379668.6396075278
        ],
        "districtid": 14
    },
    {
        "label": "Mahadeva",
        "value": 232,
        "extent": [
            9660515.21441405,
            3063591.6816910817,
            9668459.37563305,
            3071892.13047655
        ],
        "districtid": 65
    },
    {
        "label": "Mahagadhimai",
        "value": 246,
        "extent": [
            9463211.492029792,
            3114890.894765471,
            9472897.36578169,
            3127525.990910715
        ],
        "districtid": 8
    },
    {
        "label": "Mahakali",
        "value": 746,
        "extent": [
            8949655.800660426,
            3471519.904650927,
            8977609.96775499,
            3486159.8133237725
        ],
        "districtid": 16
    },
    {
        "label": "Mahakali",
        "value": 756,
        "extent": [
            8912067.792153059,
            3353306.2453262443,
            8917624.187828138,
            3373917.5704916166
        ],
        "districtid": 33
    },
    {
        "label": "Mahakulung",
        "value": 101,
        "extent": [
            9661222.840278096,
            3177067.5678375135,
            9685913.270111937,
            3233656.692124334
        ],
        "districtid": 70
    },
    {
        "label": "Mahalaxmi",
        "value": 333,
        "extent": [
            9499281.775659174,
            3197714.3688958623,
            9510644.950539043,
            3207641.4503254867
        ],
        "districtid": 38
    },
    {
        "label": "Mahalaxmi",
        "value": 77,
        "extent": [
            9712243.984105045,
            3133219.922915434,
            9730061.91881228,
            3147334.6782047953
        ],
        "districtid": 18
    },
    {
        "label": "Mahankal",
        "value": 334,
        "extent": [
            9500294.645609014,
            3173907.6153983218,
            9511507.962482432,
            3192146.2109540286
        ],
        "districtid": 38
    },
    {
        "label": "Maharajgunj",
        "value": 537,
        "extent": [
            9223892.792124208,
            3181812.951086746,
            9238938.791158147,
            3199501.3667034246
        ],
        "districtid": 34
    },
    {
        "label": "Mahashila",
        "value": 461,
        "extent": [
            9308104.22811176,
            3255556.932848051,
            9320773.148011575,
            3265809.9581853976
        ],
        "districtid": 53
    },
    {
        "label": "Mahawai",
        "value": 653,
        "extent": [
            9093733.450659234,
            3371947.0487354975,
            9130348.309458882,
            3389798.231164631
        ],
        "districtid": 32
    },
    {
        "label": "Mahottari",
        "value": 191,
        "extent": [
            9549321.316690084,
            3082117.0587696857,
            9556609.895085163,
            3091565.608156423
        ],
        "districtid": 40
    },
    {
        "label": "Mai",
        "value": 40,
        "extent": [
            9768823.874229275,
            3082507.7557622357,
            9791952.156064339,
            3106573.1946059074
        ],
        "districtid": 26
    },
    {
        "label": "Maijogmai",
        "value": 4,
        "extent": [
            9790003.418114014,
            3109441.011611118,
            9806112.742843466,
            3127918.3662386835
        ],
        "districtid": 26
    },
    {
        "label": "Maiwakhola",
        "value": 22,
        "extent": [
            9734257.89618674,
            3159880.87698347,
            9752255.268652715,
            3183656.8296902203
        ],
        "districtid": 75
    },
    {
        "label": "Makalu",
        "value": 127,
        "extent": [
            9681116.012752859,
            3186110.2654357115,
            9745458.903067585,
            3243637.3638297026
        ],
        "districtid": 64
    },
    {
        "label": "Makawanpurgadhi",
        "value": 119,
        "extent": [
            9466761.488899574,
            3168686.86985636,
            9486288.72490794,
            3187555.943318381
        ],
        "districtid": 41
    },
    {
        "label": "Malangawa",
        "value": 328,
        "extent": [
            9518792.171240717,
            3100301.9872738854,
            9527173.783543214,
            3110562.3244450153
        ],
        "districtid": 66
    },
    {
        "label": "Malarani",
        "value": 544,
        "extent": [
            9238727.58428481,
            3251485.063807777,
            9261639.689581025,
            3263344.798985886
        ],
        "districtid": 2
    },
    {
        "label": "Malika",
        "value": 214,
        "extent": [
            9248170.69236831,
            3268613.7698942926,
            9262150.396723801,
            3283155.0963367703
        ],
        "districtid": 24
    },
    {
        "label": "Malika",
        "value": 454,
        "extent": [
            9269855.160298727,
            3293746.412587629,
            9289196.353993805,
            3310624.9554461557
        ],
        "districtid": 46
    },
    {
        "label": "Malikaarjun",
        "value": 747,
        "extent": [
            8946090.26733033,
            3462236.4995099716,
            8964302.016431782,
            3475499.6345530506
        ],
        "districtid": 16
    },
    {
        "label": "Mallarani",
        "value": 551,
        "extent": [
            9218889.755964154,
            3253579.6656387215,
            9239793.299764397,
            3262910.1568364915
        ],
        "districtid": 55
    },
    {
        "label": "Manahari",
        "value": 120,
        "extent": [
            9430222.07223115,
            3168542.294312577,
            9457418.696124231,
            3199831.0539556425
        ],
        "districtid": 41
    },
    {
        "label": "Mandandeupur",
        "value": 312,
        "extent": [
            9519972.319446677,
            3206107.6841777656,
            9539461.350909028,
            3218353.8567718617
        ],
        "districtid": 30
    },
    {
        "label": "Mandavi",
        "value": 552,
        "extent": [
            9204295.32946956,
            3247779.518055388,
            9221104.02318752,
            3262042.244422922
        ],
        "districtid": 55
    },
    {
        "label": "Manebhanjyang",
        "value": 169,
        "extent": [
            9615394.861984855,
            3141814.0671415706,
            9636071.56326349,
            3158183.638347306
        ],
        "districtid": 50
    },
    {
        "label": "Mangala",
        "value": 455,
        "extent": [
            9282324.5464609,
            3289383.7008939465,
            9296708.565052824,
            3304573.6343444
        ],
        "districtid": 46
    },
    {
        "label": "Mangalsen",
        "value": 709,
        "extent": [
            9028622.01362727,
            3378586.138175531,
            9056152.718390882,
            3397043.771637919
        ],
        "districtid": 1
    },
    {
        "label": "Mangsebung",
        "value": 5,
        "extent": [
            9756709.643714461,
            3089634.337039046,
            9772591.329703921,
            3114307.3827425716
        ],
        "districtid": 26
    },
    {
        "label": "Manra Siswa",
        "value": 192,
        "extent": [
            9542667.232509868,
            3078296.1938907024,
            9550297.737030163,
            3095107.909154757
        ],
        "districtid": 40
    },
    {
        "label": "Manthali",
        "value": 357,
        "extent": [
            9571175.33071984,
            3162937.5563645638,
            9591530.098337932,
            3186442.9452362377
        ],
        "districtid": 56
    },
    {
        "label": "Marchawari",
        "value": 264,
        "extent": [
            9271968.004397199,
            3164780.252082572,
            9285117.421743592,
            3176358.780710385
        ],
        "districtid": 62
    },
    {
        "label": "Marin",
        "value": 349,
        "extent": [
            9528558.813963952,
            3141362.417439448,
            9551685.034938041,
            3167712.79657008
        ],
        "districtid": 67
    },
    {
        "label": "Marma",
        "value": 748,
        "extent": [
            8979628.978848197,
            3462996.766498664,
            9015546.416202152,
            3477620.607929376
        ],
        "districtid": 16
    },
    {
        "label": "Marsyangdi",
        "value": 299,
        "extent": [
            9377066.99665432,
            3280644.547584047,
            9419473.775072642,
            3313450.87919228
        ],
        "districtid": 39
    },
    {
        "label": "Masta",
        "value": 711,
        "extent": [
            9039723.399904067,
            3436820.7898759656,
            9057657.963488143,
            3453114.3702676147
        ],
        "districtid": 5
    },
    {
        "label": "Mathagadhi",
        "value": 220,
        "extent": [
            9302347.325659618,
            3206438.0375839686,
            9326072.826454109,
            3232835.268311468
        ],
        "districtid": 51
    },
    {
        "label": "Matihani",
        "value": 193,
        "extent": [
            9553542.190046325,
            3074111.6653807573,
            9562993.347470557,
            3083232.3345548916
        ],
        "districtid": 40
    },
    {
        "label": "Maulapur",
        "value": 450,
        "extent": [
            9480358.956008686,
            3109023.000413922,
            9488955.933306748,
            3120313.1111462535
        ],
        "districtid": 58
    },
    {
        "label": "Mayadevi",
        "value": 538,
        "extent": [
            9247131.497408561,
            3180001.6071676416,
            9259950.246654144,
            3199042.9064727942
        ],
        "districtid": 34
    },
    {
        "label": "Mayadevi",
        "value": 519,
        "extent": [
            9273710.666625839,
            3180812.871766458,
            9290309.631607285,
            3195030.6970107504
        ],
        "districtid": 62
    },
    {
        "label": "Mechinagar",
        "value": 41,
        "extent": [
            9799526.967185255,
            3068222.6596687753,
            9817028.463931374,
            3099241.8898477675
        ],
        "districtid": 28
    },
    {
        "label": "Meghang",
        "value": 437,
        "extent": [
            9460859.198680185,
            3239374.017954296,
            9476181.852514794,
            3257498.7530866424
        ],
        "districtid": 49
    },
    {
        "label": "Melamchi",
        "value": 370,
        "extent": [
            9512027.47731849,
            3216747.4060886786,
            9534397.121962026,
            3235966.249768133
        ],
        "districtid": 68
    },
    {
        "label": "Melauli",
        "value": 735,
        "extent": [
            8943952.841577532,
            3419922.705600893,
            8960508.568629786,
            3438433.5399575075
        ],
        "districtid": 4
    },
    {
        "label": "Mellekh",
        "value": 710,
        "extent": [
            9042424.42783123,
            3402248.2158828992,
            9062984.211340366,
            3417084.8573822738
        ],
        "districtid": 1
    },
    {
        "label": "Melung",
        "value": 291,
        "extent": [
            9571350.834137913,
            3185638.9865334933,
            9583874.590951875,
            3199794.553309056
        ],
        "districtid": 20
    },
    {
        "label": "Menchayam",
        "value": 124,
        "extent": [
            9736952.237334078,
            3146750.4479983086,
            9747857.685862804,
            3160628.9063088708
        ],
        "districtid": 76
    },
    {
        "label": "Meringden",
        "value": 23,
        "extent": [
            9736480.041620506,
            3168822.195682538,
            9754677.001650712,
            3198507.406664399
        ],
        "districtid": 75
    },
    {
        "label": "Miklajung",
        "value": 32,
        "extent": [
            9742769.233287303,
            3105969.267492654,
            9764056.829169748,
            3125573.3543885197
        ],
        "districtid": 52
    },
    {
        "label": "Miklajung",
        "value": 53,
        "extent": [
            9745511.465331297,
            3085980.483621701,
            9761694.65984094,
            3106422.4840629525
        ],
        "districtid": 43
    },
    {
        "label": "Mikwakhola",
        "value": 24,
        "extent": [
            9741391.81653964,
            3170632.116768271,
            9766780.91201655,
            3215910.7759011234
        ],
        "districtid": 75
    },
    {
        "label": "Mirchaiya",
        "value": 278,
        "extent": [
            9593086.792136548,
            3095740.0960946153,
            9611533.153757041,
            3109314.854880619
        ],
        "districtid": 69
    },
    {
        "label": "Mithila",
        "value": 152,
        "extent": [
            9562424.361958502,
            3106527.856657557,
            9577258.211136663,
            3140195.2391464016
        ],
        "districtid": 19
    },
    {
        "label": "Mithila Bihari",
        "value": 153,
        "extent": [
            9568631.879619038,
            3092320.7353339544,
            9578228.966060033,
            3103895.5091163265
        ],
        "districtid": 19
    },
    {
        "label": "Modi",
        "value": 462,
        "extent": [
            9312720.19392608,
            3276985.390498075,
            9331103.628124604,
            3299458.7473065024
        ],
        "districtid": 53
    },
    {
        "label": "Mohanyal",
        "value": 726,
        "extent": [
            8994098.78649668,
            3331059.8115976015,
            9048928.979963757,
            3372792.915285285
        ],
        "districtid": 31
    },
    {
        "label": "Molung",
        "value": 170,
        "extent": [
            9611149.19136595,
            3160468.6642328682,
            9630061.105689343,
            3178046.55910611
        ],
        "districtid": 50
    },
    {
        "label": "Mudkechula",
        "value": 639,
        "extent": [
            9171843.508045437,
            3372510.788668507,
            9202109.727538034,
            3393371.38936116
        ],
        "districtid": 21
    },
    {
        "label": "Mugum Karmarong",
        "value": 693,
        "extent": [
            9152787.733451517,
            3424777.6802285565,
            9220469.173744408,
            3499852.7798583442
        ],
        "districtid": 44
    },
    {
        "label": "Mukhiyapatti Musarmiya",
        "value": 154,
        "extent": [
            9556579.813238971,
            3069655.9358985126,
            9565568.31032065,
            3078215.4086125093
        ],
        "districtid": 19
    },
    {
        "label": "Musikot",
        "value": 215,
        "extent": [
            9259177.408203758,
            3261774.4843385215,
            9282297.100567887,
            3282794.837981666
        ],
        "districtid": 24
    },
    {
        "label": "Musikot",
        "value": 570,
        "extent": [
            9169088.474579122,
            3318643.3244003793,
            9192884.559501214,
            3334169.108400795
        ],
        "districtid": 61
    },
    {
        "label": "Myagde",
        "value": 337,
        "extent": [
            9359900.29320506,
            3242839.819502307,
            9378360.14459863,
            3256974.820846887
        ],
        "districtid": 74
    },
    {
        "label": "Myanglung",
        "value": 125,
        "extent": [
            9735331.370458268,
            3131263.290960559,
            9752771.648021996,
            3151043.847478158
        ],
        "districtid": 76
    },
    {
        "label": "Nagarain",
        "value": 155,
        "extent": [
            9560116.432200639,
            3075174.0872737677,
            9569750.689637557,
            3083813.4842511904
        ],
        "districtid": 19
    },
    {
        "label": "Nagarjun",
        "value": 385,
        "extent": [
            9485904.273350162,
            3209917.192846356,
            9495743.623872109,
            3218535.9995094496
        ],
        "districtid": 36
    },
    {
        "label": "Namkha",
        "value": 661,
        "extent": [
            9045392.706788363,
            3489044.9318459784,
            9120023.620153233,
            3561163.5314825596
        ],
        "districtid": 25
    },
    {
        "label": "Namobuddha",
        "value": 313,
        "extent": [
            9524018.134288406,
            3187235.5491242614,
            9542149.003556658,
            3199088.0132743865
        ],
        "districtid": 30
    },
    {
        "label": "Naraha",
        "value": 279,
        "extent": [
            9600907.597438795,
            3091415.7770702876,
            9608150.549301831,
            3100437.313920154
        ],
        "districtid": 69
    },
    {
        "label": "Naraharinath",
        "value": 654,
        "extent": [
            9068970.543525465,
            3391703.881693322,
            9082567.67045975,
            3415870.600540859
        ],
        "districtid": 32
    },
    {
        "label": "Narainapur",
        "value": 598,
        "extent": [
            9100478.098402884,
            3230534.8611859996,
            9123931.506645156,
            3248655.256409574
        ],
        "districtid": 7
    },
    {
        "label": "Narayan",
        "value": 625,
        "extent": [
            9092077.055523612,
            3350367.324723261,
            9108245.792079477,
            3369758.327781732
        ],
        "districtid": 14
    },
    {
        "label": "Narphu",
        "value": 401,
        "extent": [
            9353260.546563199,
            3320666.9482270745,
            9400472.575324636,
            3362972.277913941
        ],
        "districtid": 42
    },
    {
        "label": "Nashong",
        "value": 402,
        "extent": [
            9377628.273139939,
            3305187.682828303,
            9414338.004632972,
            3346619.4664519164
        ],
        "districtid": 42
    },
    {
        "label": "Naubahini",
        "value": 553,
        "extent": [
            9218824.375114003,
            3267622.977779732,
            9239882.806451943,
            3294756.2565245763
        ],
        "districtid": 55
    },
    {
        "label": "Naugad",
        "value": 749,
        "extent": [
            8967798.586064788,
            3467734.3794181994,
            8989022.444965752,
            3487535.156070543
        ],
        "districtid": 16
    },
    {
        "label": "Naukunda",
        "value": 415,
        "extent": [
            9487411.212305097,
            3244571.3274340373,
            9506322.008644031,
            3258199.833994338
        ],
        "districtid": 57
    },
    {
        "label": "Naumule",
        "value": 626,
        "extent": [
            9097071.99890732,
            3354222.9907995206,
            9120044.20058962,
            3378097.073836879
        ],
        "districtid": 14
    },
    {
        "label": "Nawadurga",
        "value": 765,
        "extent": [
            8974424.86543327,
            3414066.6087432094,
            8993028.562039454,
            3429861.8923344854
        ],
        "districtid": 13
    },
    {
        "label": "Nawarajpur",
        "value": 280,
        "extent": [
            9616944.21126354,
            3070222.3845566083,
            9627561.478548272,
            3079173.931824339
        ],
        "districtid": 69
    },
    {
        "label": "Nechasalyan",
        "value": 132,
        "extent": [
            9633077.226783631,
            3165763.6373749003,
            9649158.103840692,
            3174494.04217387
        ],
        "districtid": 70
    },
    {
        "label": "Nepalgunj",
        "value": 599,
        "extent": [
            9081911.525635675,
            3248574.4443603805,
            9094959.993508624,
            3265844.889385343
        ],
        "districtid": 7
    },
    {
        "label": "Neshyang",
        "value": 403,
        "extent": [
            9327365.151339138,
            3312517.0611746293,
            9377499.31679249,
            3354677.499733044
        ],
        "districtid": 42
    },
    {
        "label": "Netrawati Dabjong",
        "value": 428,
        "extent": [
            9451704.293307275,
            3242244.7835134463,
            9465671.370074231,
            3252887.4332279637
        ],
        "districtid": 17
    },
    {
        "label": "Nijgadh",
        "value": 247,
        "extent": [
            9465222.663762182,
            3138110.7319576945,
            9492312.50366396,
            3169224.32869764
        ],
        "districtid": 8
    },
    {
        "label": "Nilakantha",
        "value": 429,
        "extent": [
            9441350.747168373,
            3228985.845059825,
            9463973.570825726,
            3248574.8904490103
        ],
        "districtid": 17
    },
    {
        "label": "Nisdi",
        "value": 221,
        "extent": [
            9324265.64457044,
            3212392.3944737446,
            9354001.289198289,
            3231571.121816886
        ],
        "districtid": 51
    },
    {
        "label": "Nisikhola",
        "value": 472,
        "extent": [
            9225998.387796208,
            3283314.6491744216,
            9258728.923730474,
            3309576.3101597745
        ],
        "districtid": 3
    },
    {
        "label": "Omsatiya",
        "value": 520,
        "extent": [
            9288469.240416355,
            3185523.025920732,
            9305900.557890372,
            3194575.0737302136
        ],
        "districtid": 62
    },
    {
        "label": "Pachaljharana",
        "value": 655,
        "extent": [
            9086631.586237798,
            3398219.211160226,
            9106809.596569562,
            3419262.2793889157
        ],
        "districtid": 32
    },
    {
        "label": "Pacharauta",
        "value": 248,
        "extent": [
            9464595.601341251,
            3104637.1467429856,
            9475497.787555266,
            3119655.717934589
        ],
        "districtid": 8
    },
    {
        "label": "Painyu",
        "value": 463,
        "extent": [
            9307922.93135368,
            3249657.178647335,
            9318842.994719105,
            3260356.261581368
        ],
        "districtid": 53
    },
    {
        "label": "Pakahamainpur",
        "value": 492,
        "extent": [
            9428415.98347314,
            3123824.2262208913,
            9436135.714795953,
            3129526.205712734
        ],
        "districtid": 54
    },
    {
        "label": "Pakhribas",
        "value": 78,
        "extent": [
            9704682.059383934,
            3121138.790853585,
            9720885.918300752,
            3139489.2874430153
        ],
        "districtid": 18
    },
    {
        "label": "Palata",
        "value": 656,
        "extent": [
            9099954.132684981,
            3403445.687387352,
            9120500.063055972,
            3434527.158390583
        ],
        "districtid": 32
    },
    {
        "label": "Palhi Nandan",
        "value": 230,
        "extent": [
            9307425.639473425,
            3176824.441596091,
            9320327.968786107,
            3186350.2106454493
        ],
        "districtid": 48
    },
    {
        "label": "Palungtar",
        "value": 515,
        "extent": [
            9397450.659904232,
            3240992.130638821,
            9416038.075522318,
            3260244.325007995
        ],
        "districtid": 23
    },
    {
        "label": "Panauti",
        "value": 314,
        "extent": [
            9505215.475292092,
            3189663.4333221912,
            9525130.810151193,
            3203289.882757038
        ],
        "districtid": 30
    },
    {
        "label": "Panchadewal Binayak",
        "value": 674,
        "extent": [
            9057617.245234309,
            3378932.670968787,
            9079823.341245897,
            3397675.74738601
        ],
        "districtid": 1
    },
    {
        "label": "Panchakanya",
        "value": 438,
        "extent": [
            9491177.17636973,
            3231194.2983446796,
            9503885.276037259,
            3239378.345123776
        ],
        "districtid": 49
    },
    {
        "label": "Panchakhapan",
        "value": 128,
        "extent": [
            9707200.88753913,
            3160260.135424738,
            9734086.181940647,
            3174899.0465592262
        ],
        "districtid": 64
    },
    {
        "label": "Pancheshwar",
        "value": 736,
        "extent": [
            8932450.871695664,
            3422743.3856805535,
            8952024.096705334,
            3442442.3599361284
        ],
        "districtid": 4
    },
    {
        "label": "Panchkhal",
        "value": 315,
        "extent": [
            9524150.395141816,
            3195996.403975905,
            9543538.624204647,
            3211778.840450448
        ],
        "districtid": 30
    },
    {
        "label": "Panchpokhari Thangpal",
        "value": 371,
        "extent": [
            9520791.076225908,
            3229742.068632239,
            9544181.176546076,
            3270236.408116633
        ],
        "districtid": 68
    },
    {
        "label": "Panchpuri",
        "value": 615,
        "extent": [
            9045361.424372867,
            3332832.2839203523,
            9075111.026930759,
            3364721.5094712176
        ],
        "districtid": 72
    },
    {
        "label": "Pandav Gupha",
        "value": 671,
        "extent": [
            9079027.131915381,
            3416034.105588964,
            9099954.132684981,
            3437136.462335525
        ],
        "districtid": 6
    },
    {
        "label": "Panini",
        "value": 545,
        "extent": [
            9257488.82720433,
            3225458.514687318,
            9276297.620585255,
            3243513.1149616097
        ],
        "districtid": 2
    },
    {
        "label": "Parashuram",
        "value": 766,
        "extent": [
            8926080.808018997,
            3376431.149001066,
            8960315.740364928,
            3407902.212223467
        ],
        "districtid": 13
    },
    {
        "label": "Parbati Kunda",
        "value": 416,
        "extent": [
            9479937.169398284,
            3260574.0082995705,
            9501209.607922515,
            3291983.1214008224
        ],
        "districtid": 57
    },
    {
        "label": "Paroha",
        "value": 451,
        "extent": [
            9482707.18131332,
            3100651.756117953,
            9494660.340763973,
            3109019.0399183324
        ],
        "districtid": 58
    },
    {
        "label": "Parsa",
        "value": 331,
        "extent": [
            9531081.10956752,
            3103899.6772918864,
            9538246.979471706,
            3111332.3179344116
        ],
        "districtid": 66
    },
    {
        "label": "Parsagadhi",
        "value": 493,
        "extent": [
            9443086.342274051,
            3135631.329123691,
            9456634.43551658,
            3152970.328453988
        ],
        "districtid": 54
    },
    {
        "label": "Parsa Wildlife Reserve",
        "value": 498,
        "extent": [
            9425466.858270533,
            3152457.4094562493,
            9459159.597971851,
            3179130.5436907467
        ],
        "districtid": 54
    },
    {
        "label": "Parsa Wildlife Reserve",
        "value": 483,
        "extent": [
            9457424.488387605,
            3154766.0570195024,
            9459477.760570899,
            3162237.226554835
        ],
        "districtid": 8
    },
    {
        "label": "Parsa Wildlife Reserve",
        "value": 123,
        "extent": [
            9430416.992253609,
            3177914.730277133,
            9442769.594264051,
            3194317.6216417123
        ],
        "districtid": 41
    },
    {
        "label": "Parwanipur",
        "value": 249,
        "extent": [
            9450887.018496811,
            3127496.229386251,
            9458017.749510145,
            3133296.385089898
        ],
        "districtid": 8
    },
    {
        "label": "Patahrishanishchare",
        "value": 54,
        "extent": [
            9742828.955521991,
            3067516.373826435,
            9752257.8327283,
            3082203.880893746
        ],
        "districtid": 43
    },
    {
        "label": "Patan",
        "value": 737,
        "extent": [
            8956518.808370024,
            3424418.685872999,
            8985543.52985628,
            3441810.9462208166
        ],
        "districtid": 4
    },
    {
        "label": "Paterwasugauli",
        "value": 494,
        "extent": [
            9433162.430781674,
            3139221.8779288717,
            9444096.696725588,
            3154262.0028280453
        ],
        "districtid": 54
    },
    {
        "label": "Pathibhara Yangwarak",
        "value": 27,
        "extent": [
            9760328.544040516,
            3157579.799099901,
            9777539.88128159,
            3170743.284484636
        ],
        "districtid": 75
    },
    {
        "label": "Patrasi",
        "value": 647,
        "extent": [
            9146376.738121472,
            3404683.0211892994,
            9194006.21508928,
            3440465.6672845255
        ],
        "districtid": 29
    },
    {
        "label": "Pauwadungma",
        "value": 92,
        "extent": [
            9694890.091841847,
            3128911.4496947136,
            9708946.34482216,
            3148797.848691796
        ],
        "districtid": 11
    },
    {
        "label": "Phaktanglung",
        "value": 25,
        "extent": [
            9757155.313216468,
            3174276.65924258,
            9818551.628332123,
            3243030.5085641462
        ],
        "districtid": 75
    },
    {
        "label": "Phalebas",
        "value": 464,
        "extent": [
            9307307.356714636,
            3261548.933024652,
            9324780.632822378,
            3274563.820905811
        ],
        "districtid": 53
    },
    {
        "label": "Phatuwa Bijayapur",
        "value": 452,
        "extent": [
            9480353.940175474,
            3116647.288085451,
            9488707.371227987,
            3138110.7319576945
        ],
        "districtid": 58
    },
    {
        "label": "Phedap",
        "value": 83,
        "extent": [
            9744067.17421351,
            3137274.1450514477,
            9756664.07608504,
            3159245.8725192295
        ],
        "districtid": 76
    },
    {
        "label": "Phedikhola",
        "value": 392,
        "extent": [
            9329580.35259547,
            3266039.0432179063,
            9342717.236332811,
            3276019.565360775
        ],
        "districtid": 73
    },
    {
        "label": "Pheta",
        "value": 250,
        "extent": [
            9452276.337836703,
            3120221.8041235893,
            9459560.644168686,
            3127283.7115197564
        ],
        "districtid": 8
    },
    {
        "label": "Phidim",
        "value": 33,
        "extent": [
            9761001.117512558,
            3130289.989676493,
            9786897.704515666,
            3146639.4872427345
        ],
        "districtid": 52
    },
    {
        "label": "Phikkal",
        "value": 350,
        "extent": [
            9593585.271073215,
            3137074.399541711,
            9616862.507923748,
            3156125.44272178
        ],
        "districtid": 67
    },
    {
        "label": "Phungling",
        "value": 26,
        "extent": [
            9753909.447654089,
            3162245.338040985,
            9774500.825982379,
            3180654.3175203656
        ],
        "districtid": 75
    },
    {
        "label": "Pipra",
        "value": 194,
        "extent": [
            9554885.495759748,
            3079471.2039259397,
            9563054.377133086,
            3093293.6665664758
        ],
        "districtid": 40
    },
    {
        "label": "Pokhara Lekhnath",
        "value": 398,
        "extent": [
            9328380.73243767,
            3258768.9924833495,
            9367276.747902121,
            3292053.5513013364
        ],
        "districtid": 35
    },
    {
        "label": "Pokhariya",
        "value": 495,
        "extent": [
            9431286.281117,
            3128262.2242753548,
            9439390.074118452,
            3138170.380913423
        ],
        "districtid": 54
    },
    {
        "label": "Prasauni",
        "value": 251,
        "extent": [
            9452131.356185526,
            3125824.718654054,
            9462134.324924082,
            3133077.1713904226
        ],
        "districtid": 8
    },
    {
        "label": "Pratappur",
        "value": 231,
        "extent": [
            9322476.48004045,
            3170843.948075002,
            9332922.035561586,
            3185252.550721373
        ],
        "districtid": 48
    },
    {
        "label": "Punarbas",
        "value": 757,
        "extent": [
            8949767.016066868,
            3318714.79014353,
            8967246.399842333,
            3340915.6347661447
        ],
        "districtid": 33
    },
    {
        "label": "Purbakhola",
        "value": 222,
        "extent": [
            9315101.86851746,
            3218215.533124551,
            9338929.625921477,
            3235366.450999259
        ],
        "districtid": 51
    },
    {
        "label": "Purbichauki",
        "value": 685,
        "extent": [
            9016845.57150167,
            3400517.5823538136,
            9031969.62614367,
            3419362.948290955
        ],
        "districtid": 22
    },
    {
        "label": "Purchaudi",
        "value": 738,
        "extent": [
            8970727.706363808,
            3443264.563819323,
            8993586.658174593,
            3462426.5850581056
        ],
        "districtid": 4
    },
    {
        "label": "Putalibazar",
        "value": 393,
        "extent": [
            9327600.496448446,
            3252915.946720639,
            9351359.972738637,
            3268092.3265795927
        ],
        "districtid": 73
    },
    {
        "label": "Putha Uttarganga",
        "value": 753,
        "extent": [
            9200938.761814287,
            3313982.1031360836,
            9237924.3693971,
            3350757.664771162
        ],
        "districtid": 60
    },
    {
        "label": "Pyuthan",
        "value": 554,
        "extent": [
            9214634.093503138,
            3257363.613025906,
            9234952.199020827,
            3272774.8493387774
        ],
        "districtid": 55
    },
    {
        "label": "Raghuganga",
        "value": 456,
        "extent": [
            9286320.048565067,
            3296262.667500294,
            9308241.02123863,
            3337185.15136907
        ],
        "districtid": 46
    },
    {
        "label": "Rainadevi Chhahara",
        "value": 223,
        "extent": [
            9265223.994060308,
            3218261.814430821,
            9286261.111302197,
            3243785.863883385
        ],
        "districtid": 51
    },
    {
        "label": "Rainas",
        "value": 300,
        "extent": [
            9398833.723154213,
            3255972.6957831024,
            9412550.762090087,
            3269301.287051525
        ],
        "districtid": 39
    },
    {
        "label": "Rajapur",
        "value": 608,
        "extent": [
            9023455.960556967,
            3294932.0820491402,
            9040748.22086765,
            3311894.931419853
        ],
        "districtid": 9
    },
    {
        "label": "Rajbiraj",
        "value": 233,
        "extent": [
            9652989.467815166,
            3058910.606364342,
            9663402.130457249,
            3072205.2456155047
        ],
        "districtid": 65
    },
    {
        "label": "Rajdevi",
        "value": 478,
        "extent": [
            9493741.874075282,
            3091600.557246408,
            9501256.789709182,
            3100728.6202531424
        ],
        "districtid": 58
    },
    {
        "label": "Rajpur",
        "value": 589,
        "extent": [
            9135293.364253227,
            3208312.514392952,
            9183620.171730129,
            3245957.151827604
        ],
        "districtid": 15
    },
    {
        "label": "Rajpur",
        "value": 479,
        "extent": [
            9485959.208036711,
            3095536.6611714675,
            9494476.387419451,
            3104548.055306958
        ],
        "districtid": 58
    },
    {
        "label": "Raksirang",
        "value": 121,
        "extent": [
            9430675.046857912,
            3184710.7516113655,
            9458240.210923448,
            3210248.8066903027
        ],
        "districtid": 41
    },
    {
        "label": "Ramaroshan",
        "value": 675,
        "extent": [
            9054463.427008685,
            3390547.610326595,
            9072483.936906563,
            3412271.664973131
        ],
        "districtid": 1
    },
    {
        "label": "Rambha",
        "value": 224,
        "extent": [
            9309871.437277386,
            3224919.657994568,
            9323794.242146727,
            3239829.6745077623
        ],
        "districtid": 51
    },
    {
        "label": "Ramdhuni",
        "value": 71,
        "extent": [
            9696871.270956336,
            3077934.9783782596,
            9713091.168294318,
            3092283.806250465
        ],
        "districtid": 71
    },
    {
        "label": "Ramechhap",
        "value": 358,
        "extent": [
            9575786.200099299,
            3153751.6768582254,
            9600251.302003734,
            3173889.4002483394
        ],
        "districtid": 56
    },
    {
        "label": "Ramgopalpur",
        "value": 195,
        "extent": [
            9544616.508440815,
            3094515.699155413,
            9554045.813579451,
            3105161.8888999736
        ],
        "districtid": 40
    },
    {
        "label": "Ramgram",
        "value": 254,
        "extent": [
            9304813.938983733,
            3182317.782704536,
            9319402.82622,
            3196664.2005471075
        ],
        "districtid": 48
    },
    {
        "label": "Ramnagar",
        "value": 343,
        "extent": [
            9499279.535308663,
            3100664.7886250853,
            9509598.139098343,
            3106048.9445609935
        ],
        "districtid": 66
    },
    {
        "label": "Ramprasad Rai",
        "value": 93,
        "extent": [
            9675539.944825705,
            3125177.5273051215,
            9698641.888069468,
            3142086.9274577186
        ],
        "districtid": 11
    },
    {
        "label": "Rampur",
        "value": 225,
        "extent": [
            9323367.082342546,
            3224144.823788413,
            9350857.68985751,
            3237635.865837907
        ],
        "districtid": 51
    },
    {
        "label": "Rangeli",
        "value": 55,
        "extent": [
            9729667.101497523,
            3051324.3698949525,
            9745274.243706295,
            3068327.4626639597
        ],
        "districtid": 43
    },
    {
        "label": "Rapti",
        "value": 590,
        "extent": [
            9195027.695881085,
            3226065.608704602,
            9218375.04929012,
            3238933.915208725
        ],
        "districtid": 15
    },
    {
        "label": "Rapti",
        "value": 505,
        "extent": [
            9416261.885684863,
            3194069.144846071,
            9439509.26383952,
            3215698.9450136153
        ],
        "districtid": 12
    },
    {
        "label": "Rapti Sonari",
        "value": 600,
        "extent": [
            9096111.87878822,
            3239105.1051946105,
            9149801.287229687,
            3283789.165669231
        ],
        "districtid": 7
    },
    {
        "label": "Raskot",
        "value": 688,
        "extent": [
            9083807.803349152,
            3403129.1166890394,
            9092963.977569358,
            3418187.185273613
        ],
        "districtid": 32
    },
    {
        "label": "Ratnanagar",
        "value": 506,
        "extent": [
            9402651.957087932,
            3192202.554855537,
            9413363.836343043,
            3208846.670517696
        ],
        "districtid": 12
    },
    {
        "label": "Ratuwamai",
        "value": 56,
        "extent": [
            9748707.847586095,
            3046322.2149838023,
            9760394.526777852,
            3072320.4691076605
        ],
        "districtid": 43
    },
    {
        "label": "Rautamai",
        "value": 104,
        "extent": [
            9638558.597836582,
            3108947.8432357027,
            9658568.268671209,
            3131761.092812105
        ],
        "districtid": 77
    },
    {
        "label": "Rawa Besi",
        "value": 174,
        "extent": [
            9642687.581535459,
            3151559.3834096794,
            9661093.154742338,
            3166755.906213666
        ],
        "districtid": 37
    },
    {
        "label": "Resunga",
        "value": 216,
        "extent": [
            9261858.381180948,
            3247202.6432620552,
            9275880.214115998,
            3264168.963049679
        ],
        "districtid": 24
    },
    {
        "label": "Rhishing",
        "value": 338,
        "extent": [
            9364228.216827568,
            3227858.221970044,
            9388081.829079483,
            3245073.30930047
        ],
        "districtid": 74
    },
    {
        "label": "Ribdikot",
        "value": 226,
        "extent": [
            9277973.043990813,
            3222565.3518289197,
            9294415.368239785,
            3241850.4287851537
        ],
        "districtid": 51
    },
    {
        "label": "Rohini",
        "value": 521,
        "extent": [
            9291124.172179466,
            3182259.9754814277,
            9307931.083505189,
            3190229.302026831
        ],
        "districtid": 62
    },
    {
        "label": "Rolpa",
        "value": 560,
        "extent": [
            9186252.212049749,
            3277204.3937264937,
            9208937.73592728,
            3303965.314910498
        ],
        "districtid": 59
    },
    {
        "label": "Rong",
        "value": 6,
        "extent": [
            9791977.409956632,
            3091678.5224883338,
            9816680.265529037,
            3106645.347024206
        ],
        "districtid": 26
    },
    {
        "label": "Roshi",
        "value": 316,
        "extent": [
            9523012.153469143,
            3173302.930228578,
            9550195.164862907,
            3190986.5217074635
        ],
        "districtid": 30
    },
    {
        "label": "Rubi Valley",
        "value": 109,
        "extent": [
            9457842.381301798,
            3262432.3411385473,
            9484896.239968307,
            3292733.7269247975
        ],
        "districtid": 17
    },
    {
        "label": "Runtigadi",
        "value": 561,
        "extent": [
            9172359.364164798,
            3260662.562658394,
            9198467.785218483,
            3282014.449262912
        ],
        "districtid": 59
    },
    {
        "label": "Rupa",
        "value": 399,
        "extent": [
            9363038.400214354,
            3260878.4202331197,
            9376367.280264251,
            3273573.510881638
        ],
        "districtid": 35
    },
    {
        "label": "Rupakot Majhuwagadhi",
        "value": 175,
        "extent": [
            9650332.064312404,
            3141556.2431482915,
            9675150.812995177,
            3163851.6898052962
        ],
        "districtid": 37
    },
    {
        "label": "Rupani",
        "value": 234,
        "extent": [
            9649589.828123894,
            3068268.3389860345,
            9658139.51988601,
            3087567.9487118893
        ],
        "districtid": 65
    },
    {
        "label": "Ruru",
        "value": 217,
        "extent": [
            9281050.326469105,
            3240225.6238342104,
            9292257.997618608,
            3253257.7424343005
        ],
        "districtid": 24
    },
    {
        "label": "Sabaila",
        "value": 156,
        "extent": [
            9578845.87255684,
            3091585.650245227,
            9590711.002696691,
            3103816.526615415
        ],
        "districtid": 19
    },
    {
        "label": "Sabhapokhari",
        "value": 129,
        "extent": [
            9710897.94832169,
            3168894.979731414,
            9737293.026850311,
            3187636.260344585
        ],
        "districtid": 64
    },
    {
        "label": "Sahid Lakhan",
        "value": 516,
        "extent": [
            9410971.762436315,
            3231064.526844854,
            9433174.727031305,
            3248713.57014426
        ],
        "districtid": 23
    },
    {
        "label": "Sahidnagar",
        "value": 157,
        "extent": [
            9579177.588715233,
            3083533.5707609323,
            9590652.309321279,
            3097002.6348549984
        ],
        "districtid": 19
    },
    {
        "label": "Sailung",
        "value": 292,
        "extent": [
            9560594.694321584,
            3193166.867053106,
            9582214.265207212,
            3207795.6270131785
        ],
        "districtid": 20
    },
    {
        "label": "Sainamaina",
        "value": 522,
        "extent": [
            9262974.412045179,
            3204314.3572703237,
            9283291.135580873,
            3219772.8824626864
        ],
        "districtid": 62
    },
    {
        "label": "Sakela",
        "value": 176,
        "extent": [
            9662588.768535987,
            3137250.38137119,
            9676955.618678289,
            3154770.9471188914
        ],
        "districtid": 37
    },
    {
        "label": "Sakhuwanankarkatti",
        "value": 281,
        "extent": [
            9619632.591125462,
            3072728.689697946,
            9630563.671171483,
            3081437.984624837
        ],
        "districtid": 69
    },
    {
        "label": "SakhuwaPrasauni",
        "value": 496,
        "extent": [
            9436872.147081487,
            3134069.584565053,
            9450329.446920995,
            3153593.5763563816
        ],
        "districtid": 54
    },
    {
        "label": "Salpasilichho",
        "value": 94,
        "extent": [
            9674320.670854587,
            3161694.809214491,
            9700404.47959847,
            3181510.513025112
        ],
        "districtid": 11
    },
    {
        "label": "Sammarimai",
        "value": 523,
        "extent": [
            9268134.555797962,
            3165387.9913659836,
            9279552.830806797,
            3177654.8012545407
        ],
        "districtid": 62
    },
    {
        "label": "Samsi",
        "value": 196,
        "extent": [
            9542405.152206419,
            3094686.0822286643,
            9548698.203639904,
            3105537.023185584
        ],
        "districtid": 40
    },
    {
        "label": "Sandakpur",
        "value": 7,
        "extent": [
            9780552.493386121,
            3121963.7203473733,
            9801647.257508505,
            3136745.410415719
        ],
        "districtid": 26
    },
    {
        "label": "Sandhikharka",
        "value": 546,
        "extent": [
            9245644.928472003,
            3235133.7621303857,
            9263811.587756226,
            3254073.399702609
        ],
        "districtid": 2
    },
    {
        "label": "Sangurigadhi",
        "value": 79,
        "extent": [
            9702853.426822012,
            3104193.2880094824,
            9731617.892545855,
            3117975.9180966187
        ],
        "districtid": 18
    },
    {
        "label": "Sani Bheri",
        "value": 571,
        "extent": [
            9153864.556467226,
            3325541.602353869,
            9175062.373962056,
            3341715.9919177396
        ],
        "districtid": 61
    },
    {
        "label": "Sanni Tribeni",
        "value": 689,
        "extent": [
            9075184.273053441,
            3395823.1311945673,
            9088565.600895979,
            3422915.794682378
        ],
        "districtid": 32
    },
    {
        "label": "Sanphebagar",
        "value": 676,
        "extent": [
            9030605.013441965,
            3395694.7437421754,
            9046835.256092962,
            3421646.246137938
        ],
        "districtid": 1
    },
    {
        "label": "Saptakoshi",
        "value": 235,
        "extent": [
            9670340.530146303,
            3082059.221751265,
            9683019.227389826,
            3094329.499680897
        ],
        "districtid": 65
    },
    {
        "label": "Sarawal",
        "value": 255,
        "extent": [
            9317377.227960164,
            3174697.9035365945,
            9325215.16407495,
            3199760.1569494866
        ],
        "districtid": 48
    },
    {
        "label": "Sarkegad",
        "value": 662,
        "extent": [
            9102988.70067742,
            3461720.612125298,
            9133058.276130686,
            3491445.7239302015
        ],
        "districtid": 25
    },
    {
        "label": "Sarumarani",
        "value": 555,
        "extent": [
            9210623.502682216,
            3233563.5728013245,
            9233132.341745935,
            3250325.2793753855
        ],
        "districtid": 55
    },
    {
        "label": "Satyawati",
        "value": 218,
        "extent": [
            9282232.526089555,
            3244418.4364804295,
            9300727.599686986,
            3261126.8405607697
        ],
        "districtid": 24
    },
    {
        "label": "Sayal",
        "value": 686,
        "extent": [
            9003355.301561642,
            3412660.004283642,
            9022751.557190139,
            3432490.3180363616
        ],
        "districtid": 22
    },
    {
        "label": "Shadananda",
        "value": 95,
        "extent": [
            9686074.889524512,
            3155174.8343963306,
            9708137.3657464,
            3176098.8137755874
        ],
        "districtid": 11
    },
    {
        "label": "Shahidbhumi",
        "value": 76,
        "extent": [
            9701291.043517709,
            3111723.5104628294,
            9716106.175609821,
            3125056.0171832414
        ],
        "districtid": 18
    },
    {
        "label": "Shailyashikhar",
        "value": 750,
        "extent": [
            8956678.437815523,
            3459005.4462670623,
            8981539.426735703,
            3472687.5908024707
        ],
        "districtid": 16
    },
    {
        "label": "Shambhunath",
        "value": 236,
        "extent": [
            9643154.251728073,
            3066647.352497912,
            9656390.80063938,
            3087253.9756032946
        ],
        "districtid": 65
    },
    {
        "label": "Shankharapur",
        "value": 386,
        "extent": [
            9509808.666219072,
            3213174.7871361426,
            9525133.101314384,
            3222778.869412573
        ],
        "districtid": 36
    },
    {
        "label": "Shantinagar",
        "value": 591,
        "extent": [
            9140973.63719841,
            3262114.3896202934,
            9156404.55868934,
            3280729.1311973487
        ],
        "districtid": 15
    },
    {
        "label": "Sharada",
        "value": 581,
        "extent": [
            9132842.101921711,
            3288659.4404550917,
            9158904.178463615,
            3307342.9625367536
        ],
        "districtid": 63
    },
    {
        "label": "Shey Phoksundo",
        "value": 640,
        "extent": [
            9206329.84914891,
            3380708.054997173,
            9269306.239698812,
            3465862.1997706224
        ],
        "districtid": 21
    },
    {
        "label": "Shikhar",
        "value": 687,
        "extent": [
            8983685.362143468,
            3391606.531335281,
            9009449.133754766,
            3422013.262681629
        ],
        "districtid": 22
    },
    {
        "label": "Shivanath",
        "value": 739,
        "extent": [
            8935736.993191749,
            3414952.3082927796,
            8949111.452240406,
            3434284.472010254
        ],
        "districtid": 4
    },
    {
        "label": "Shivapuri",
        "value": 439,
        "extent": [
            9493169.049187867,
            3225799.934266786,
            9514492.376193618,
            3235332.3478431315
        ],
        "districtid": 49
    },
    {
        "label": "Shivapuri Watershed and Wildlife Reserve",
        "value": 443,
        "extent": [
            9492577.319724467,
            3222944.7789050452,
            9512159.227169266,
            3228501.169643038
        ],
        "districtid": 49
    },
    {
        "label": "Shivaraj",
        "value": 539,
        "extent": [
            9209595.906174399,
            3194653.0488847992,
            9232318.677880567,
            3223241.561748264
        ],
        "districtid": 34
    },
    {
        "label": "Shivasataxi",
        "value": 42,
        "extent": [
            9769967.820105275,
            3064027.356557799,
            9783176.245197915,
            3085295.269560657
        ],
        "districtid": 28
    },
    {
        "label": "Shiwalaya",
        "value": 633,
        "extent": [
            9108154.665308518,
            3329409.5756408996,
            9132710.540528756,
            3343480.8466504556
        ],
        "districtid": 27
    },
    {
        "label": "Shuklagandaki",
        "value": 339,
        "extent": [
            9344105.955873972,
            3249781.7108147163,
            9372502.692494422,
            3263597.2040888574
        ],
        "districtid": 74
    },
    {
        "label": "Shuklaphanta",
        "value": 758,
        "extent": [
            8940581.17205922,
            3350663.5188551117,
            8956692.15750199,
            3381710.171701558
        ],
        "districtid": 33
    },
    {
        "label": "Shuklaphanta National Park",
        "value": 759,
        "extent": [
            8916397.207850702,
            3341707.652596396,
            8948375.808688585,
            3382543.0538184214
        ],
        "districtid": 33
    },
    {
        "label": "Siddhalek",
        "value": 110,
        "extent": [
            9436000.097964913,
            3223446.2775596846,
            9455888.618656343,
            3235893.496805426
        ],
        "districtid": 17
    },
    {
        "label": "Siddharthanagar",
        "value": 524,
        "extent": [
            9283115.849257044,
            3183008.7900380907,
            9294428.247086365,
            3190967.7976441137
        ],
        "districtid": 62
    },
    {
        "label": "Siddhicharan",
        "value": 171,
        "extent": [
            9621646.200205034,
            3151389.4659397905,
            9643836.900012283,
            3180362.721363814
        ],
        "districtid": 50
    },
    {
        "label": "Sidingba",
        "value": 2,
        "extent": [
            9777318.637149414,
            3158374.774214886,
            9803669.275482547,
            3178851.713914631
        ],
        "districtid": 75
    },
    {
        "label": "Sigas",
        "value": 740,
        "extent": [
            8979601.989751788,
            3422146.8067242964,
            9006654.500097899,
            3443870.494934799
        ],
        "districtid": 4
    },
    {
        "label": "Silichong",
        "value": 130,
        "extent": [
            9678121.875174863,
            3178050.1964078946,
            9706461.818039147,
            3214830.2845479697
        ],
        "districtid": 64
    },
    {
        "label": "Simkot",
        "value": 663,
        "extent": [
            9093046.080412218,
            3491630.1713073184,
            9139090.403811494,
            3550565.856047724
        ],
        "districtid": 25
    },
    {
        "label": "Simraungadh",
        "value": 252,
        "extent": [
            9472017.598200655,
            3106869.6026608986,
            9481852.910896918,
            3115155.416072042
        ],
        "districtid": 8
    },
    {
        "label": "Simta",
        "value": 616,
        "extent": [
            9113331.68295431,
            3305182.3179635787,
            9132696.454426631,
            3330564.2594280955
        ],
        "districtid": 72
    },
    {
        "label": "Sinja",
        "value": 648,
        "extent": [
            9119768.12415446,
            3411141.396493001,
            9142699.62704757,
            3427273.561610594
        ],
        "districtid": 29
    },
    {
        "label": "Siraha",
        "value": 282,
        "extent": [
            9589776.568378331,
            3072143.2840760397,
            9603701.862924289,
            3087897.020929392
        ],
        "districtid": 69
    },
    {
        "label": "Siranchok",
        "value": 517,
        "extent": [
            9407745.923483407,
            3250538.342660714,
            9425012.315056322,
            3268995.052450154
        ],
        "districtid": 23
    },
    {
        "label": "Sirijangha",
        "value": 3,
        "extent": [
            9771023.7994187,
            3160033.304656299,
            9813332.200599212,
            3211449.8402381297
        ],
        "districtid": 75
    },
    {
        "label": "Sisne",
        "value": 754,
        "extent": [
            9182265.777185293,
            3319728.8364307038,
            9213437.4783088,
            3359002.319583061
        ],
        "districtid": 60
    },
    {
        "label": "Sitganga",
        "value": 547,
        "extent": [
            9211494.726044282,
            3217532.64633432,
            9268292.254353415,
            3240471.10637201
        ],
        "districtid": 2
    },
    {
        "label": "Siyari",
        "value": 525,
        "extent": [
            9276767.451825762,
            3188048.5436357,
            9290972.731204655,
            3201725.8189168256
        ],
        "districtid": 62
    },
    {
        "label": "Solududhakunda",
        "value": 133,
        "extent": [
            9621876.592363417,
            3172101.0494658966,
            9651967.309816277,
            3218348.0857067844
        ],
        "districtid": 70
    },
    {
        "label": "Sonama",
        "value": 197,
        "extent": [
            9537417.719390227,
            3101032.6762516936,
            9547511.26002483,
            3112545.048223681
        ],
        "districtid": 40
    },
    {
        "label": "Soru",
        "value": 657,
        "extent": [
            9104078.930642502,
            3442375.6512247035,
            9140852.696096778,
            3471573.284761675
        ],
        "districtid": 44
    },
    {
        "label": "Sotang",
        "value": 164,
        "extent": [
            9653959.37706787,
            3177372.113506985,
            9667883.597040225,
            3199079.622587059
        ],
        "districtid": 70
    },
    {
        "label": "Suddhodhan",
        "value": 540,
        "extent": [
            9256445.899989104,
            3175774.4130795095,
            9265448.307872135,
            3198481.826141825
        ],
        "districtid": 34
    },
    {
        "label": "Sudhdhodhan",
        "value": 526,
        "extent": [
            9275542.566537429,
            3194698.6049352097,
            9287609.985803682,
            3206155.92948831
        ],
        "districtid": 62
    },
    {
        "label": "Sukhipur",
        "value": 283,
        "extent": [
            9606401.291584255,
            3080541.2352853543,
            9618788.187671222,
            3090860.347563669
        ],
        "districtid": 69
    },
    {
        "label": "Sukidaha",
        "value": 562,
        "extent": [
            9167187.532240786,
            3294755.509677562,
            9181551.055917054,
            3315795.471465173
        ],
        "districtid": 59
    },
    {
        "label": "Sulikot",
        "value": 518,
        "extent": [
            9423139.016544707,
            3254324.040522707,
            9439854.19916266,
            3295755.768921636
        ],
        "districtid": 23
    },
    {
        "label": "Sunapati",
        "value": 359,
        "extent": [
            9550922.820819134,
            3179029.9586993423,
            9564276.74929244,
            3194891.168987506
        ],
        "districtid": 56
    },
    {
        "label": "Sunchhahari",
        "value": 563,
        "extent": [
            9206362.479302105,
            3284859.506612203,
            9234688.408653298,
            3309461.4362192918
        ],
        "districtid": 59
    },
    {
        "label": "Sundarbazar",
        "value": 301,
        "extent": [
            9382042.21269478,
            3262972.0778810848,
            9400371.996515773,
            3274206.6756503326
        ],
        "districtid": 39
    },
    {
        "label": "Sundarharaicha",
        "value": 57,
        "extent": [
            9716501.87972449,
            3073778.0475911256,
            9730225.973994719,
            3088116.5029881606
        ],
        "districtid": 43
    },
    {
        "label": "Sunkoshi",
        "value": 105,
        "extent": [
            9637221.175937321,
            3126767.095566027,
            9652644.330978643,
            3142522.5043421015
        ],
        "districtid": 77
    },
    {
        "label": "Sunkoshi",
        "value": 351,
        "extent": [
            9548248.671266029,
            3162210.563118601,
            9571593.053653063,
            3179926.487029262
        ],
        "districtid": 67
    },
    {
        "label": "Sunkoshi",
        "value": 172,
        "extent": [
            9604740.476661744,
            3147536.807644816,
            9623662.042038197,
            3168053.489774439
        ],
        "districtid": 50
    },
    {
        "label": "Sunkoshi",
        "value": 372,
        "extent": [
            9543450.791890115,
            3206794.824884828,
            9559057.79850662,
            3218293.2277497654
        ],
        "districtid": 68
    },
    {
        "label": "Sunwal",
        "value": 256,
        "extent": [
            9303153.864058848,
            3191138.687913118,
            9322815.982278746,
            3210355.6742412145
        ],
        "districtid": 48
    },
    {
        "label": "Sunwarshi",
        "value": 58,
        "extent": [
            9740200.17130574,
            3047918.872118199,
            9752205.431040334,
            3070624.0408386257
        ],
        "districtid": 43
    },
    {
        "label": "Surma",
        "value": 712,
        "extent": [
            9019353.932558075,
            3447912.0709779016,
            9041680.295067593,
            3480792.2377415085
        ],
        "districtid": 5
    },
    {
        "label": "Surnaya",
        "value": 741,
        "extent": [
            8958742.156475788,
            3437308.1414042795,
            8985964.749752011,
            3449055.164268113
        ],
        "districtid": 4
    },
    {
        "label": "Surunga",
        "value": 237,
        "extent": [
            9628945.032486102,
            3072951.012765182,
            9639251.82484037,
            3097386.071829191
        ],
        "districtid": 65
    },
    {
        "label": "Suryabinayak",
        "value": 412,
        "extent": [
            9502301.537231153,
            3201129.696144629,
            9517106.665261857,
            3207941.930605557
        ],
        "districtid": 10
    },
    {
        "label": "Suryagadhi",
        "value": 440,
        "extent": [
            9484534.609398443,
            3237012.7263681353,
            9496822.635334581,
            3247415.324823238
        ],
        "districtid": 49
    },
    {
        "label": "Suryodaya",
        "value": 8,
        "extent": [
            9788346.374748481,
            3097037.7333272793,
            9815555.80648977,
            3124488.8697515335
        ],
        "districtid": 26
    },
    {
        "label": "Susta",
        "value": 257,
        "extent": [
            9329898.87854632,
            3166847.468583762,
            9340402.442472637,
            3187408.2854497307
        ],
        "districtid": 48
    },
    {
        "label": "Suwarna",
        "value": 253,
        "extent": [
            9461333.835558137,
            3109614.4105258165,
            9471832.969454557,
            3118977.74820979
        ],
        "districtid": 8
    },
    {
        "label": "Suwarnabati",
        "value": 564,
        "extent": [
            9196648.890135687,
            3271381.6617750674,
            9217166.105513178,
            3296582.7581665944
        ],
        "districtid": 59
    },
    {
        "label": "Swami Kartik",
        "value": 672,
        "extent": [
            9095448.285622917,
            3419262.2793889157,
            9106836.448214853,
            3440117.108738449
        ],
        "districtid": 6
    },
    {
        "label": "Sworgadwary",
        "value": 556,
        "extent": [
            9193669.731011981,
            3255553.6177216107,
            9217186.623947239,
            3275664.791229572
        ],
        "districtid": 55
    },
    {
        "label": "Tadi",
        "value": 441,
        "extent": [
            9491416.91757243,
            3237940.6388160037,
            9503835.269632462,
            3251336.399524423
        ],
        "districtid": 49
    },
    {
        "label": "Talkot",
        "value": 713,
        "extent": [
            9030687.463367213,
            3445078.768935424,
            9068884.230271555,
            3481136.0513325273
        ],
        "districtid": 5
    },
    {
        "label": "Tamakoshi",
        "value": 293,
        "extent": [
            9581831.44433968,
            3182822.1610391675,
            9594207.638539681,
            3200272.771106117
        ],
        "districtid": 20
    },
    {
        "label": "Taman Khola",
        "value": 473,
        "extent": [
            9256363.02403785,
            3294892.800293064,
            9272953.154142233,
            3313905.3363014674
        ],
        "districtid": 3
    },
    {
        "label": "Tanjakot",
        "value": 664,
        "extent": [
            9094462.67036448,
            3452857.03091545,
            9110192.154310158,
            3478092.2314389325
        ],
        "districtid": 25
    },
    {
        "label": "Tansen",
        "value": 227,
        "extent": [
            9286188.225279052,
            3223000.275298364,
            9304473.181124808,
            3241504.8555796575
        ],
        "districtid": 51
    },
    {
        "label": "Tapli",
        "value": 106,
        "extent": [
            9625861.595470287,
            3126149.8481827127,
            9640902.255061023,
            3142034.0339275957
        ],
        "districtid": 77
    },
    {
        "label": "Tarakeshwor",
        "value": 421,
        "extent": [
            9490131.099603757,
            3216079.570091843,
            9498734.467308631,
            3225643.280595458
        ],
        "districtid": 36
    },
    {
        "label": "Tara Khola",
        "value": 474,
        "extent": [
            9273141.70232845,
            3279755.1268232153,
            9293363.94703826,
            3295887.6162763927
        ],
        "districtid": 3
    },
    {
        "label": "Tarkeshwar",
        "value": 442,
        "extent": [
            9460901.913029872,
            3227841.2312090024,
            9472954.183993101,
            3240470.6316288263
        ],
        "districtid": 49
    },
    {
        "label": "Tatopani",
        "value": 649,
        "extent": [
            9129444.371664181,
            3371741.306260909,
            9159152.684806304,
            3413360.0780834197
        ],
        "districtid": 29
    },
    {
        "label": "Temal",
        "value": 317,
        "extent": [
            9539103.4731564,
            3178368.6910895114,
            9553594.493444676,
            3196706.837570326
        ],
        "districtid": 30
    },
    {
        "label": "Thaha",
        "value": 122,
        "extent": [
            9458543.157564588,
            3195964.7892952547,
            9484994.886773635,
            3212735.8544480917
        ],
        "districtid": 41
    },
    {
        "label": "Thakre",
        "value": 111,
        "extent": [
            9461914.800105002,
            3209962.94836375,
            9477517.304104509,
            3221743.915303442
        ],
        "districtid": 17
    },
    {
        "label": "Thakurbaba",
        "value": 528,
        "extent": [
            9041544.807487518,
            3295062.0878158556,
            9055986.011312133,
            3314952.868202109
        ],
        "districtid": 9
    },
    {
        "label": "Thalara",
        "value": 703,
        "extent": [
            9007010.993381225,
            3426333.74000687,
            9031727.752437506,
            3440028.2854326214
        ],
        "districtid": 5
    },
    {
        "label": "Thantikandh",
        "value": 627,
        "extent": [
            9070474.778770871,
            3367039.897377638,
            9086021.108076919,
            3382469.8435086673
        ],
        "districtid": 14
    },
    {
        "label": "Thasang",
        "value": 408,
        "extent": [
            9295701.959522929,
            3320351.28758779,
            9321536.166215837,
            3351987.1117172805
        ],
        "districtid": 45
    },
    {
        "label": "Thawang",
        "value": 565,
        "extent": [
            9196523.12121273,
            3298522.3812777405,
            9224950.160942668,
            3315521.0418196837
        ],
        "districtid": 59
    },
    {
        "label": "Thori",
        "value": 497,
        "extent": [
            9404690.61057085,
            3149191.060745829,
            9433840.250959404,
            3172774.8938593464
        ],
        "districtid": 54
    },
    {
        "label": "Thuli Bheri",
        "value": 641,
        "extent": [
            9205101.188912343,
            3351298.4120510397,
            9242938.753315018,
            3388898.6634686245
        ],
        "districtid": 21
    },
    {
        "label": "Thulung Dudhkoshi",
        "value": 97,
        "extent": [
            9641322.150777465,
            3169068.513186758,
            9664134.008523658,
            3184928.8652831702
        ],
        "districtid": 70
    },
    {
        "label": "Tikapur",
        "value": 727,
        "extent": [
            9018318.414985761,
            3298794.2297540344,
            9035565.61034993,
            3319001.4213352744
        ],
        "districtid": 31
    },
    {
        "label": "Tila",
        "value": 650,
        "extent": [
            9116460.112182995,
            3387704.1089932285,
            9135370.668582965,
            3411090.9934171936
        ],
        "districtid": 29
    },
    {
        "label": "Tilagufa",
        "value": 690,
        "extent": [
            9099267.718409691,
            3382466.654038941,
            9125450.387837509,
            3406416.0424872707
        ],
        "districtid": 32
    },
    {
        "label": "Tilathi Koiladi",
        "value": 238,
        "extent": [
            9657739.631686145,
            3055504.0901344973,
            9668293.722164655,
            3064559.7515274854
        ],
        "districtid": 65
    },
    {
        "label": "Tillotama",
        "value": 527,
        "extent": [
            9285572.73760849,
            3192399.7658669287,
            9300943.654227743,
            3207817.814458676
        ],
        "districtid": 62
    },
    {
        "label": "Tinau",
        "value": 228,
        "extent": [
            9277374.783459803,
            3211825.394112846,
            9306071.945351975,
            3227482.3806526624
        ],
        "districtid": 51
    },
    {
        "label": "Tinpatan",
        "value": 352,
        "extent": [
            9573279.932763875,
            3129338.651084235,
            9602005.617930455,
            3150772.324796046
        ],
        "districtid": 67
    },
    {
        "label": "Tirahut",
        "value": 265,
        "extent": [
            9664510.26997604,
            3067607.014229679,
            9673947.720703593,
            3077718.819879681
        ],
        "districtid": 65
    },
    {
        "label": "Tokha",
        "value": 430,
        "extent": [
            9496344.941024981,
            3215556.0422136155,
            9501105.63778375,
            3225683.8205508674
        ],
        "districtid": 36
    },
    {
        "label": "Tribeni",
        "value": 582,
        "extent": [
            9142512.167864427,
            3278896.4557006396,
            9165537.762869246,
            3291331.009720548
        ],
        "districtid": 63
    },
    {
        "label": "Tribeni",
        "value": 566,
        "extent": [
            9168592.370652214,
            3275465.0852031796,
            9193554.76368469,
            3296247.9122744864
        ],
        "districtid": 59
    },
    {
        "label": "Tribeni",
        "value": 572,
        "extent": [
            9167418.063171158,
            3314808.6008004327,
            9183299.83270867,
            3326707.138289203
        ],
        "districtid": 61
    },
    {
        "label": "Tribeni",
        "value": 673,
        "extent": [
            9050597.05799319,
            3410289.0674652625,
            9079129.11171671,
            3426465.548527257
        ],
        "districtid": 6
    },
    {
        "label": "Tribeni Nalagad",
        "value": 634,
        "extent": [
            9150215.00250915,
            3339347.034708342,
            9192771.209467545,
            3377749.9122680626
        ],
        "districtid": 27
    },
    {
        "label": "Tripurasundari",
        "value": 642,
        "extent": [
            9196560.45170685,
            3362519.2714406187,
            9229160.691315442,
            3393225.961536944
        ],
        "districtid": 21
    },
    {
        "label": "Tripurasundari",
        "value": 373,
        "extent": [
            9557964.358229697,
            3211781.5691907746,
            9577258.38955257,
            3222800.1330749826
        ],
        "districtid": 68
    },
    {
        "label": "Tripura Sundari",
        "value": 112,
        "extent": [
            9436510.0731282,
            3244861.1632608003,
            9455968.679389488,
            3257799.590208858
        ],
        "districtid": 17
    },
    {
        "label": "Triyuga",
        "value": 107,
        "extent": [
            9634722.5189533,
            3084324.4500151663,
            9667170.893178882,
            3116600.3749714894
        ],
        "districtid": 77
    },
    {
        "label": "Tulsipur",
        "value": 592,
        "extent": [
            9150675.903174732,
            3244438.2320736153,
            9176140.046198854,
            3280341.476673027
        ],
        "districtid": 15
    },
    {
        "label": "Tumbewa",
        "value": 34,
        "extent": [
            9739615.092977865,
            3114337.8135719346,
            9757969.89105301,
            3128533.6638890305
        ],
        "districtid": 52
    },
    {
        "label": "Turmakhad",
        "value": 677,
        "extent": [
            9049739.025387092,
            3343636.3642671416,
            9081657.774487745,
            3378783.084389203
        ],
        "districtid": 1
    },
    {
        "label": "Tyamkemaiyung",
        "value": 96,
        "extent": [
            9673071.146517271,
            3135621.2448232872,
            9690319.790860696,
            3162685.902043676
        ],
        "districtid": 11
    },
    {
        "label": "Udayapurgadhi",
        "value": 108,
        "extent": [
            9623267.605944116,
            3096237.2837588578,
            9641989.636655662,
            3129400.5324152783
        ],
        "districtid": 77
    },
    {
        "label": "Umakunda",
        "value": 239,
        "extent": [
            9597155.832215596,
            3180438.030821929,
            9637222.769126432,
            3227866.147847267
        ],
        "districtid": 56
    },
    {
        "label": "Uralabari",
        "value": 59,
        "extent": [
            9747991.803973032,
            3068384.4780786117,
            9757745.547918223,
            3088802.0075463373
        ],
        "districtid": 43
    },
    {
        "label": "Uttargaya",
        "value": 417,
        "extent": [
            9475775.07593546,
            3245557.2233445556,
            9489225.12979083,
            3270269.5685442677
        ],
        "districtid": 57
    },
    {
        "label": "Waling",
        "value": 394,
        "extent": [
            9313397.862307124,
            3238817.5405738633,
            9336011.550553242,
            3255363.3484305507
        ],
        "districtid": 73
    },
    {
        "label": "Yangwarak",
        "value": 35,
        "extent": [
            9770241.216256414,
            3150465.978554558,
            9805033.209699042,
            3178336.5326401666
        ],
        "districtid": 52
    },
    {
        "label": "Yashodhara",
        "value": 541,
        "extent": [
            9234534.522208137,
            3179663.801461982,
            9249596.751213474,
            3188630.872590804
        ],
        "districtid": 34
    },
    {
        "label": "Yemunamai",
        "value": 480,
        "extent": [
            9492219.698179444,
            3099472.218212265,
            9497827.211733423,
            3108180.521542412
        ],
        "districtid": 58
    }
]
